/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from "react";
import { inicio, TIPO_TK_PROCESADO, URL_ENVIO_FOMULARIO, ENTORNO } from '../../API/CONSTANTS/constants';
import { ESTILOS_COLORES } from "../../API/CONSTANTS/constants";

import { ConfigProvider, Button, Space, Tooltip, Image, Select, DatePicker, Checkbox, Input } from 'antd';
import esES from 'antd/es/locale/es_ES';
import type { DatePickerProps, RangePickerProps } from 'antd/es/date-picker';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';



import moment from 'moment';

import 'moment/locale/es';

import logoSTK from "../../ASSETS/images/logo-starken.png";

import DataTable, { Alignment } from "react-data-table-component";


import {
    SearchOutlined, FormOutlined, CloseCircleOutlined,
    CheckCircleFilled, RightSquareFilled, EditFilled, ProfileFilled, RocketOutlined,
    QuestionCircleOutlined, CheckCircleOutlined, PictureOutlined, SyncOutlined,
    // @ts-ignore
    ConsoleSqlOutlined,
} from '@ant-design/icons';


import type { CheckboxProps } from 'antd';


import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp, faInfoCircle, faBox } from "@fortawesome/free-solid-svg-icons";






import { OverlayTrigger, Modal, Spinner, Alert, Container, Row, Col, Card, Pagination, Form, Stack, InputGroup, ProgressBar } from "react-bootstrap";

import { InvierteFecha, HoraCorrecta, CaracteresEspeciales, OrdenaFechaServer, formatoFechaQuery } from "../../SHARED/Formatos";


import { ActualizaColor, CalcularFechaAnterior, CalcularSieteMesesAntes, cancelar, cargaImagenes, contruyeStringConsulta, desTraducirTipoTicket, FiltroFechasRezago, FiltroFechasTipoTicket, SinDatos } from "./Services/AccionesBC";


import AlertaCentral from "../../SHARED/CentralAlertas";

//DTOS
import { ModalInfo } from "./Entities/modalInfo.DTO";

import Menu from "../../CONTAINERS/menu/menu";
import NoImage from "../../ASSETS/images/foto sin  foto.jpg";

import Topdesk from "../../API/MICROSERVICES/topdesk/topdesk";
import { DelaySeg } from "../../SHARED/temporizadores";

import { IsOnLine, validarEstado, validarOf, validarTopdeskOfOriginal, validarTopdeskOfTicket } from "./Services/ValidadorBC";

import { abrirFormulario, CalculoFechaEnvioRezago, direcEstado, direcRezago, TrackingDetalle, TraeAgencias, TraeColores, traeRezago, traeRezagoOF, traeTicketResuelto, TraeTipoTicket, TraeUbicacionFisica } from "./Services/OperadoresBC";
import { clippingParents } from "@popperjs/core";
import Observaciones from "../../API/MICROSERVICES/observaciones/observaciones";


const { RangePicker } = DatePicker;

let images: any[] = [];

let VariablePaso: string;

type FormElement = React.FormEvent<HTMLFormElement>;

// @ts-ignore
export default function Busqueda_BC(props: any) {

    moment.locale('es');

    // TODO: importaciones de NPL 

    const { StopwordsEs } = require('@nlpjs/lang-es');
    const { TokenizerEs } = require('@nlpjs/lang-es');



    let random = Math.random() * Math.random() + Math.random() * Math.random();

    const [numeroAPI, setnumeroAPI] = useState(7);
    const [nomColor, setnomColor] = useState("primary")

    const TK_01 = TIPO_TK_PROCESADO.TIPO_TK_01_REDESTINAR;
    const TK_02 = TIPO_TK_PROCESADO.TIPO_TK_02_DEVOLVER;
    const TK_03 = TIPO_TK_PROCESADO.TIPO_TK_03_SACAR_A_REPARTO;
    const TK_04 = TIPO_TK_PROCESADO.TIPO_TK_04_CAMBIAR_TIPO_ENTREGA;

    const [modalInfoDto, setModalInfoDto] = useState({} as ModalInfo);

    // @ts-ignore
    const [modalInfoRezagoDto, setModalRezagoInfoDto] = useState({} as ModalInfo);

    const [OptionAgencias, setOptionAgencias] = useState([] as any[]);
    const [OptionColores, setOptionColores] = useState([] as any[]);
    const [OptionsTipoTicket, setOptionsTipoTicket] = useState([] as any[]);

    const [OrdenFleteRezago, setOrdeFleteRezago] = useState(String);
    const [OrdenFleteOriginal, setOrdeFleteOriginal] = useState(String);
    const [DiasRezago, setDiasRezago] = useState(String);
    const [MotivoRezago, setMotivoRezago] = useState(String);
    const [LargoMotivo, setLargoMotivo] = useState(String);

    const [OrdenFleteRezago2, setOrdenFleteRezago2] = useState(String);
    const [OrdenFleteOriginal2, setOrdenFleteOriginal2] = useState(String);
    const [DiasRezago2, setDiasRezago2] = useState(String);
    const [MotivoRezago2, setMotivoRezago2] = useState(String);
    const [LargoMotivo2, setLargoMotivo2] = useState(String);

    const [EncargoSeleccionado, setEncargoSeleccionado] = useState("");
    const [IndexEncargoSeleccionado, setIndexEncargoSeleccionado] = useState("");
    const [ESBoton, setESBoton] = useState(false);

    const [AletaOf, setAlertaOf] = useState(false);

    const [IsOriginal, setIsOriginal] = useState(false);
    const [OFTieneRTezago, setOFTieneRTezago] = useState(false);

    const [AccionRezago, setAccionRezago] = useState(false);

    const [DisableBotonEnvio, setDisableBotonEnvio] = useState(false);

    const [progress, setProgress] = useState(false);


    const [estadoBotonBultoCiego, setEstadoBotonBultoCiego] = useState(true);

    const [show1, setShow1] = useState(false);
    const handleClose1 = () => { setShowU(false); setShow1(false); };

    const [show2, setShow2] = useState(false);
    const handleClose2 = () => { setShowU(false); setShow2(false); };

    const [show3, setShow3] = useState(false);
    const handleClose3 = () => { setShowU(false); setShow3(false); };

    const [enableViewRezago, setEnableViewRezago] = useState(false); // FALSE OCULTA LA SECCION DE REZAGO
    const [enableViewGestionar, setEnableViewGestionar] = useState(false);



    const [enableViewSinOf, setEnableViewSinOf] = useState(false);

    const Color_Main_BackGround = ESTILOS_COLORES.MAIN_BACKGROUND;
    const Color_Sucursales = ESTILOS_COLORES.SUCURSALES;
    const Color_Colores = ESTILOS_COLORES.COLORES;
    const Color_Tickets = ESTILOS_COLORES.TICKETS;
    const Color_Fechas = ESTILOS_COLORES.FECHAS;
    const Color_PalabrasClaves = ESTILOS_COLORES.PALABRAS_CLAVES;
    const Color_BackGround_Limpieza = ESTILOS_COLORES.BACKGROUND_LIMPIEZA;
    const Color_Limpieza = ESTILOS_COLORES.LIMPIEZA;
    const Color_Blanco = ESTILOS_COLORES.BLANCO;
    const Color_Verde = ESTILOS_COLORES.VERDE;
    const Color_Rojo = ESTILOS_COLORES.ROJO;

    const Color_Ticket_SinEstado = ESTILOS_COLORES.TICKET_SIN_ESTADO;
    const Color_Ticket_Original = ESTILOS_COLORES.TICKET_ORIGINAL;
    const Color_Ticket_Redestinado = ESTILOS_COLORES.TICKET_REDESTINADO;
    const Color_Ticket_Devuelto = ESTILOS_COLORES.TICKET_DEVUELTO;
    const Color_Ticket_Rezago = ESTILOS_COLORES.TICKET_REZAGO;
    const Color_Ticket_Sobrante = "LemonChiffon";

    const Color_Encabezado = ESTILOS_COLORES.ENCABEZADO;
    const Color_Footer = ESTILOS_COLORES.FOOTER;
    const Color_Gris = ESTILOS_COLORES.GRIS;
    const Color_Negro = ESTILOS_COLORES.NEGRO;
    const Color_Verde_Agua = ESTILOS_COLORES.VERDE_AGUA;
    const Color_Amarillo_Canario = ESTILOS_COLORES.AMARILLO_CANARIO;


    const [idSucursal, setIdSucursal] = useState("");
    const [nombreSucursal, setNombreSucursal] = useState("");
    const [idColor, setIdColor] = useState("");
    const [nombreColors, setNombreColors] = useState("");

    const [nombreTipoTk, setnombreTipoTk] = useState("");
    const [nombreFecha, setNombreFecha] = useState("");
    const [nombrePalabra, setNombrePalabra] = useState("");

    const [selectorAccionInfo, setselectorAccionInfo] = useState("null");

    const [recuperacionTicket, setrecuperacionTicket] = useState("");
    const [recuperacionAgente, setrecuperacionAgente] = useState("");
    const [recuperacionTipo, setrecuperacionTipo] = useState("");
    const [recuperacionOrdenflete, setrecuperacionOrdenFlete] = useState("Sin Datos");

    const [idFechaRango, setIdFechaRango] = useState([] as any[]);
    const [FechaInicio, setFechaInicio] = useState("");
    const [FechaFinal, setFechaFinal] = useState("");

    const [idTipoTicket, setIdTipoTicket] = useState("MINI TICKET");


    const [color, setColor] = useState(Color_Verde);
    const [colorCardHeader, setColorCardHeader] = useState("linear-gradient(rgb(233, 255, 235), rgb(242, 248, 244)");
    const [eleccion, setEleccion] = useState("");
    const [mensaje, setMensaje] = useState("La paciencia es la clave del triunfo.");
    const [totalTK, setTotalTK] = useState(0);


    const [oFOrifinal, setOFOrifinal] = useState("");
    const [EncaCodigoBarra, setEncaCodigoBarra] = useState("");
    const [FechaComprmiso, setFechaComprmiso] = useState("");
    const [EstadoProcesoCodigo, setEstadoProcesoCodigo] = useState("");
    const [RespuestaSegundaParte, setRespuestaSegundaParte] = useState({} as any);

    const [EncaCodigoBarra2, setEncaCodigoBarra2] = useState("");
    const [FechaCompromiso2, setFechaCompromiso2] = useState("");
    const [EstadoProcesoCodigo2, setEstadoProcesoCodigo2] = useState("");


    const [checkedColor, setCheckedColor] = useState(false);
    const [checkedSucursal, setCheckedSucursal] = useState(false);
    const [checkedTipoTicket, setCheckedTipoTicket] = useState(false);
    const [checkedRangoFecha, setCheckedRangoFecha] = useState(false);
    const [checkedPalabraClave, setCheckedPalabraClave] = useState(false);

    const [cantidadPorPagina, setCantidadPorPagina] = useState(16);
    const [currentPage, setCurrentPage] = useState(1);
    const totalPages = Math.ceil(images.length / cantidadPorPagina);
    const handlePageChange = (page: any) => {
        setCurrentPage(page);
    };


    const [CargaBarra, setCargaBarra] = useState(0);

    const startIndex = (currentPage - 1) * cantidadPorPagina;
    const endIndex = startIndex + cantidadPorPagina;
    const currentImages = images.slice(startIndex, endIndex);


    const [titulo, setTitulo] = useState("");
    const [estado,] = useState(false)
    const [busquedaCiega, setBusquedaCiega] = useState(false); // habilita que se vea la galeria

    const [show, setShow] = useState(false);
    const handleClose = () => { setShow(false); setShow(false); };

    const [permitirBuscar, setPermitirBuscar] = useState(false);

    const [frame1, setframe1] = useState(true);
    const [frame2, setframe2] = useState(true);
    const [frame3, setframe3] = useState(true);
    const [frame4, setframe4] = useState(true);
    const [frame5, setframe5] = useState(true);

    const dateFormat = 'DD/MM/YYYY';

    async function soloFrame1() {

        const stateforzaro = async () => {

            await setframe1(false);
            await setframe2(true);
            await setframe3(true);
            await setframe4(true);
            await setframe5(true);
        }
        await stateforzaro();
    }

    async function soloFrame2() {

        const stateforzaro = async () => {

            await setframe1(true);
            await setframe2(false);
            await setframe3(true);
            await setframe4(true);
            await setframe5(true);
        }
        await stateforzaro();
    }

    async function soloFrame3() {

        const stateforzaro = async () => {

            await setframe1(true);
            await setframe2(true);
            await setframe3(false);
            await setframe4(true);
            await setframe5(true);
        }
        await stateforzaro();
    }

    async function soloFrame4() {

        const stateforzaro = async () => {

            await setframe1(true);
            await setframe2(true);
            await setframe3(true);
            await setframe4(false);
            await setframe5(true);
        }
        await stateforzaro();
    }

    async function soloFrame5() {

        const stateforzaro = async () => {

            await setframe1(true);
            await setframe2(true);
            await setframe3(true);
            await setframe4(true);
            await setframe5(false);
        }
        await stateforzaro();
    }

    const onChangeDP = (
        value: DatePickerProps['value'] | RangePickerProps['value'],
        dateString: [string, string] | string,
    ) => {

        let arregloFecha: any[] = [dateString[0], dateString[1]];

        nombreFechas(dateString);
        forzarFecha(arregloFecha);
        setPermitirBuscar(true);
    };

    const onChange: CheckboxProps['onChange'] = (e) => {

        let valor = e.target.checked;

        if (valor) {
            setEstadoBotonBultoCiego(false);
            setIsOriginal(false);
            VariablePaso = "ticket";


        } else {
            setEstadoBotonBultoCiego(true);
            forzarIsOriginal();
            VariablePaso = "original";
        }
    };

    const nombreFechas = (fecha: any) => {

        const StateForzadoInicio = () => {
            return setNombreFecha("" + fecha[0] + " -> " + fecha[1]);
        }

        StateForzadoInicio();

    }

    const forzarFecha = (arreglo: any[]) => {

        const StateForzadoInicio = () => {
            return setIdFechaRango(arreglo);;
        }

        StateForzadoInicio();
    }

    const forzarTotalTK = (total: any) => {

        const StateForzado = () => {
            return setTotalTK(total);;
        }

        StateForzado();

    }

    const { history } = props;    // para los cambios de pagina

    //TODO: validacion portal cautivo

    // function validacion() {
    //     if (inicio.permitido === false) {
    //         PaginaError();
    //     }
    // }

    // function PaginaError() {
    //     history.push("/InValidDomain");
    // }

    // useEffect(() => {
    //     validacion();
    //     // eslint-disable-next-line
    // }, [])

    //=====================================================================================

    const [mostrar, setMostrar] = useState(false);

    const [showU, setShowU] = useState(false);

    const onChangeAgencia = (value: string) => {

        let id: string = value;

        const StateForzado = () => {
            return setIdSucursal(id);
        }

        nombreAgencia(id);
        StateForzado();
        setPermitirBuscar(true);

    };

    const nombreAgencia = async (id: string) => {

        let nombreAgencia: any[] = await OptionAgencias.filter(item => (item.value == id));

        const StateForzado = () => {
            setNombreSucursal(nombreAgencia[0].label);
        }

        StateForzado();

    }

    const nombreColor = async (id: string) => {

        let nombreColor: any[] = await OptionColores.filter(item => (item.value == id));

        const StateForzado = () => {
            setNombreColors(nombreColor[0].label);
        }

        StateForzado();

    }

    const onSearchAgencia = (value: string) => {

    };

    const onChangeColor = (value: string) => {

        let id: string = value;
        const StateForzado = () => {
            return setIdColor(id);
        }

        nombreColor(id);
        StateForzado();
        setPermitirBuscar(true);
    };



    // TODO:  Palabras capturadas

    const onChangePalabraClave = (value: string) => {

        console.log("palabra clave ", value);

        let palabra: string = value;

        let largo: number = palabra.length;

        let arrayFinales: any[] = [];

        if (largo > 3) {

            const stopwords = new StopwordsEs();

            const tokenizer = new TokenizerEs();

            const tokenizado = tokenizer.tokenize(palabra, true);

            let palabras_limpias = stopwords.removeStopwords(tokenizado);

            palabras_limpias.map((word: string) => {

                let largo: number = word.length;
                if (largo > 3) {
                    arrayFinales.push(word);
                }

                return null;
            });

        }

        let palabraFinal = "";

        arrayFinales.map((palabra) => {

            palabraFinal = palabraFinal + " " + palabra;

            return null;
        });

        forzarPalabraClave(palabraFinal);

        setPermitirBuscar(true);

    }


    const forzarPalabraClave = (palabra: string) => {

        const StateForzado = () => {
            return setNombrePalabra(palabra);
        }

        StateForzado();

    }

    const onSearchColor = (value: string) => {

    };

    const handleTicket = (value: string | string[]) => {

        let id: string = "" + value;

        const StateForzado = () => {
            return setIdTipoTicket(id);
        }

        NobreTipoTicket(value);
        StateForzado();
    };

    const NobreTipoTicket = async (nombre: any) => {

        let nombreTipoTicket = await desTraducirTipoTicket(nombre);

        const StateForzado = async () => {
            return setnombreTipoTk(nombreTipoTicket);
        }

        await StateForzado();
        setPermitirBuscar(true);

    }

    const handleSelectColor = (e: CheckboxChangeEvent) => {


        let color = e.target.checked;

        const forzado = (forzado: any) => {
            return setCheckedColor(forzado);
        }

        forzado(color);

        return new Promise((resolve, reject) => {
            resolve(setCheckedColor(e.target.checked));
        });
    };

    const handleSelectSucursal = (e: CheckboxChangeEvent) => {


        let color = e.target.checked;

        const forzado = (forzado: any) => {
            return setCheckedSucursal(forzado);
        }

        forzado(color);

        return new Promise((resolve, reject) => {
            resolve(setCheckedSucursal(e.target.checked));
        });
    };

    const handleSelectTipoTicket = (e: CheckboxChangeEvent) => {

        let tipoticket = e.target.checked;

        const forzado = (forzado: any) => {
            return setCheckedTipoTicket(forzado);
        }

        forzado(tipoticket);

        return new Promise((resolve, reject) => {
            resolve(setCheckedTipoTicket(e.target.checked));
        });
    };

    const handleSelectRangoFecha = (e: CheckboxChangeEvent) => {

        let rango = e.target.checked;

        const forzado = (forzado: any) => {
            return setCheckedRangoFecha(rango);
        }

        forzado(color);

        return new Promise((resolve, reject) => {
            resolve(setCheckedRangoFecha(e.target.checked));
        });
    };

    const handleSelectPalabraClave = (e: CheckboxChangeEvent) => {

        // console.log(e);

        let palabra = e.target.checked;

        const forzado = (forzado: any) => {
            return setCheckedPalabraClave(forzado);
        }

        forzado(palabra);

        return new Promise((resolve, reject) => {
            resolve(setCheckedPalabraClave(e.target.checked));
        });

    };

    useEffect(() => { }, [checkedColor, checkedSucursal, checkedTipoTicket, checkedRangoFecha, checkedPalabraClave]);

    //================================================================================================================


    async function ValidacionesPrevias(galeria: any[]) {


        let arrayResp: any[] = []

        galeria.forEach((ticket: any) => {

            let ordenFlete = ticket.optionalFields1.text2;


            let LargoOrdenFlete = ordenFlete.length;

            if (LargoOrdenFlete > 7 && LargoOrdenFlete < 10) {

                let tipoTicket = (ticket.optionalFields2.searchlist2?.name != null || ticket.optionalFields2.searchlist2?.name != undefined) ? ticket.optionalFields2.searchlist2.name : "Sin Datos";
                ticket.optionalFields2.searchlist2 = { name: tipoTicket };
                ticket.starken = { sinof: "Si-Tiene" };
                arrayResp.push(ticket);

            } else {

                let tipoTicket = (ticket.optionalFields2.searchlist2?.name != null || ticket.optionalFields2.searchlist2?.name != undefined) ? ticket.optionalFields2.searchlist2.name : "Sin Datos";
                ticket.optionalFields2.searchlist2 = { name: tipoTicket };
                ticket.starken = { sinof: "No-Tiene" };
                arrayResp.push(ticket);

            }

            return null;
        });



        // console.log("arrayResp -->", arrayResp);

        return arrayResp;

    }


    async function construirGaleria(galeria: any[]) {

        // console.log("01 - Construir Galeria");

        setShowU(true);

        let sucursales: any[] = galeria;


        if (sucursales !== undefined) {

            // console.log("02 - No es undefined");

            let otroLargo = sucursales.length;

            if (otroLargo > 0) {

                // console.log("03 - Es mayor que 0");

                let numeroCantidad: number = 0;

                sucursales.forEach(async (item, index) => {

                    // console.log("04 - REcorriendo --> ", index + 1);

                    let ordenFlete: any = (item.optionalFields1.text2 != null || item.optionalFields1.text2 != "." || item.optionalFields1.text2 != ",") ? item.optionalFields1.text2 : "Sin Datos";

                    let est; //TODO: Estado de orden de flete string

                    if (item.starken.sinof == "Si-Tiene") {

                        est = await direcEstado(item.optionalFields1.text2);

                        // console.log(" 05 estado ordenflete -->", est);

                        let img: any[] = [];

                        if (item.optionalFields2.memo1 != undefined) {
                            if (item.optionalFields2.memo1 != null) {

                                let imagen: string = item.optionalFields2.memo1;
                                let imagenes: any[] = []

                                // console.log("06 imagen -->", imagen);

                                imagenes = await cargaImagenes(imagen);

                                if (imagenes.length > 0) {

                                    img = imagenes;
                                }
                            }
                        }

                        let colors;

                        try {
                            if (item.optionalFields1.searchlist4.name != undefined) {

                                if (item.optionalFields1.searchlist4.name != null) {

                                    // console.log("07 - Tiene color");

                                    colors = item.optionalFields1.searchlist4.name;
                                } else {
                                    colors = "Sin Color";
                                }
                            } else {
                                colors = "Sin Color";
                            }


                        } catch (e) {

                            colors = "Sin Color";

                        }




                        let categoria;

                        if (ENTORNO.ENTORNO == "PRODUCCION" || ENTORNO.ENTORNO == "LOCAL_PRD") {
                            categoria = item.optionalFields2.searchlist3 != null ? item.optionalFields2.searchlist3.id : "null";
                        } else {
                            categoria = item.optionalFields2.searchlist3 != null ? item.optionalFields2.searchlist3.id : "null";
                        }



                        // console.log("08 - Tiene Categoria", categoria);

                        let suc = item.caller.branch.name;

                        let obs = String(item.request);

                        let sucursal: ModalInfo = {
                            "ticket": item.number,
                            "imagenes": img,
                            "obs": obs,
                            "hora": item.creationDate,
                            "fecha": item.creationDate,
                            "creador": item.caller.dynamicName,
                            "ordenFlete": item.optionalFields1.text2,
                            "color": colors,
                            "alto": item.optionalFields1.number2,
                            "largo": item.optionalFields1.number3,
                            "ancho": item.optionalFields1.number4,
                            "peso": item.optionalFields1.number5,
                            "categoria": categoria,
                            "ticketRecuperado": item.externalNumber,
                            "ticketRecuperadoPOR": "",
                            "tipoTicket": item.optionalFields2.searchlist2.name,
                            "largoObs": "",
                            "agencia": suc,
                            "fechaEnvioRezago": "",
                            "fechaCreacionOf": "",
                            "sinOF": item.starken.sinof
                        }


                        // console.log("09 sucursal --> ", sucursal);

                        try {
                            setShowU(true);

                            let reza: any = await direcRezago(item.optionalFields1.text2);

                            // console.log("10 - datos rezago", reza);

                            let largo = reza.length;

                            if (largo != 0 && reza[0].fechaEntrega != "-1") {

                                // console.log("11 - Rezago");

                                let select: any = await FiltroFechasRezago(reza[0].fechaEntrega);

                                // console.log("12 - resultado filtro rezago");

                                if (select.visible) {

                                    if (est.estado == "1" && categoria == "null") {

                                        // console.log("13 - NO es visible");

                                    } else {

                                        // console.log("14 - es visible");

                                        numeroCantidad = numeroCantidad + 1;
                                        images.push(sucursal);
                                    }

                                } else {


                                }

                                setShowU(false);

                            } else {

                                setShowU(true);



                                // console.log("item.creationDate ", item.creationDate);

                                let selector: any = await FiltroFechasTipoTicket(item.creationDate, categoria);


                                // console.log("15 - Filtro Fechas tipo ticket ", selector);

                                if (selector.visible) {
                                    if (est.estado == "1" && categoria == "null") {

                                        // console.log(" 16 - No es Visible");

                                    } else {

                                        // console.log(" 17 - ES Visible");

                                        numeroCantidad = numeroCantidad + 1;
                                        images.push(sucursal);
                                    }
                                } else {

                                }

                                setShowU(false);
                            }


                            await forzarTotalTK(numeroCantidad);

                        } catch (e) { setShowU(false); }

                    } else {



                        let img: any[] = [];

                        if (item.optionalFields2.memo1 != undefined) {
                            if (item.optionalFields2.memo1 != null) {

                                let imagen: string = item.optionalFields2.memo1;
                                let imagenes: any[] = []

                                imagenes = await cargaImagenes(imagen);

                                if (imagenes.length > 0) {

                                    img = imagenes;
                                }
                            }
                        }

                        let colors;

                        try {
                            if (item.optionalFields1.searchlist4.name != undefined) {

                                if (item.optionalFields1.searchlist4.name != null) {

                                    colors = item.optionalFields1.searchlist4.name;
                                } else {
                                    colors = "Sin Color";
                                }
                            } else {
                                colors = "Sin Color";
                            }


                        } catch (e) {

                            colors = "Sin Color";

                        }


                        let categoria;

                        if (ENTORNO.ENTORNO == "PRODUCCION" || ENTORNO.ENTORNO == "LOCAL_PRD") {
                            categoria = item.optionalFields2.searchlist3 != null ? item.optionalFields2.searchlist3.id : "null";
                        } else {
                            categoria = item.optionalFields2.searchlist3 != null ? item.optionalFields2.searchlist3.id : "null";
                        }


                        let suc = item.caller.branch.name;

                        let obs = String(item.request);

                        let sucursal: ModalInfo = {
                            "ticket": item.number,
                            "imagenes": img,
                            "obs": obs,
                            "hora": item.creationDate,
                            "fecha": item.creationDate,
                            "creador": item.caller.dynamicName,
                            "ordenFlete": item.optionalFields1.text2,
                            "color": colors,
                            "alto": item.optionalFields1.number2,
                            "largo": item.optionalFields1.number3,
                            "ancho": item.optionalFields1.number4,
                            "peso": item.optionalFields1.number5,
                            "categoria": categoria,
                            "ticketRecuperado": item.externalNumber,
                            "ticketRecuperadoPOR": "",
                            "tipoTicket": item.optionalFields2.searchlist2.name,
                            "largoObs": "",
                            "agencia": suc,
                            "fechaEnvioRezago": "",
                            "fechaCreacionOf": "",
                            "sinOF": item.starken.sinof
                        }

                        numeroCantidad = numeroCantidad + 1;
                        images.push(sucursal);

                        // console.log("images --> ", images);

                        await forzarTotalTK(numeroCantidad);

                    }



                })

            }

            setTimeout(() => {
                setBusquedaCiega(true);
                //  setBusquedaCiega(false);
                setShowU(false);

            }, 2);
            setShowU(true);
        }

        setShowU(false);
    }

    const handleSubmit = (e: FormElement) => { // inicio handleSubmit
        e.preventDefault();
        forzarIsOriginal();
        setShowU(true);
        AccionIngresarOfOriginal(modalInfoDto);
    }; // final handleSubmit

    // primero esta funcion 01 ========================================================================================
    async function cargaOptions() {

        setShowU(true);
        cambiaMensaje();


        let agencias: any[] = await TraeAgencias();

        let ArrayAgencias: any[] = [];

        try {

            agencias.map((age: any) => {

                let agencia = {
                    label: age.name,
                    value: age.id,
                }

                ArrayAgencias.push(agencia);

                return null;
            });

        } catch (e) { }

        setTimeout(() => {
            setOptionAgencias(ArrayAgencias);
        }, 1);


        let colores: any[] = await TraeColores();

        let ArrayColores: any[] = [];

        try {

            colores.map((age: any) => {

                let color = {
                    label: age.name,
                    value: age.id,
                }

                ArrayColores.push(color);

                return null;
            });

        } catch (e) { }

        setTimeout(() => {
            setOptionColores(ArrayColores);
        }, 1);



        let tipoTickets: any[] = await TraeTipoTicket();

        let ArrayTipo: any[] = [];

        try {
            tipoTickets.forEach((tipo: any) => {

                let leb = (tipo.name).toUpperCase();

                let tip = {
                    value: tipo.id,
                    label: leb
                }

                ArrayTipo.push(tip);
            });

            setTimeout(() => {
                setOptionsTipoTicket(ArrayTipo);
            }, 1);



        } catch (e) { }

        setShowU(false);

    }


    useEffect(() => {

        cargaOptions();

    }, []);




    // =================================================================================================================
    async function cambiaMensaje() {

        let mensaje1 = "¡Estamos preparando todo para ti!";
        let mensaje2 = "La paciencia es una virtud.";
        let mensaje3 = "Estamos recogiendo píxeles \n para formar la imagen perfecta.";
        let mensaje4 = "Por favor,\n espera un momento.";
        let mensaje5 = "Gracias por ser virtuoso\n mientras preparamos todo.";
        let mensaje6 = "¡Casi listo!";

        await DelaySeg(2);

        setMensaje(mensaje1);

        await DelaySeg(2);

        setMensaje(mensaje2);

        await DelaySeg(2);

        setMensaje(mensaje3);

        await DelaySeg(2);

        setMensaje(mensaje4);

        await DelaySeg(2);

        setMensaje(mensaje5);

        await DelaySeg(2);

        setMensaje(mensaje6);

        await DelaySeg(2);

        setMensaje("Estamos trabajando juntos hacia la grandeza.");

        setShowU(false);
    }

    useEffect(() => { }, [enableViewRezago])

    const [arrayEncargos, setArrayEncargos] = useState([] as any);

    const [arrayEncargosOriginales, setArrayEncargosOriginales] = useState([] as any);

    async function cargaRezago(encacodigobarra: string) {

        let MensajeRezago: string = "Encargo sin Rezago";

        try {

            let DATA = await traeRezago(encacodigobarra);

            let rezago = DATA.data;

            if (rezago.codigo_ORDEN_FLETE_REZAGO != "-1") {

                setOrdeFleteRezago(rezago.codigo_ORDEN_FLETE_REZAGO);
                setDiasRezago(rezago.dias_REZAGO);
                setMotivoRezago(rezago.motivo_REZAGO.trim());
                setOrdeFleteOriginal(rezago.codigo_ORDEN_FLETE_ORIGINAL);


                let largo: string = "" + rezago.motivo_REZAGO.trim().length;
                setLargoMotivo(largo);

                let motivo: string = "" + rezago.motivo_REZAGO;


                if (selectorAccionInfo == "null") {
                    if (motivo != null) {
                        if (motivo != "No ingreso Orden de Flete") {
                            forzarEstadoRezago();
                            forzarOFTieneRTezago();
                        } else { }
                    } else { }
                } else { }
            } else {

                setOrdeFleteRezago("");
                setDiasRezago("");
                setMotivoRezago("");
                setOrdeFleteOriginal("");
                setLargoMotivo("0");

                const forzar = async () => {
                    await setEnableViewRezago(false);
                    await setOFTieneRTezago(false);
                };

                await forzar();


            }

        } catch (e) {

            setOrdeFleteRezago(MensajeRezago);
            setDiasRezago(MensajeRezago);
            setMotivoRezago(MensajeRezago);
            setOrdeFleteOriginal(MensajeRezago);
            setLargoMotivo("0");

            const forzar = async () => {
                await setEnableViewRezago(false);
                await setOFTieneRTezago(false);
            };

            await forzar();
        }

    }

    async function cargaRezagoOF(ordenFlete: string) {

        let MensajeRezago: string = "Encargo sin Rezago";

        try {

            let DATA = await traeRezagoOF(ordenFlete);

            let rezago = DATA;


            if (rezago.codigo_ORDEN_FLETE_REZAGO != "-1") {

                setOrdeFleteRezago(rezago.codigo_ORDEN_FLETE_REZAGO);
                setDiasRezago(rezago.dias_REZAGO);
                setMotivoRezago(rezago.motivo_REZAGO.trim());
                setOrdeFleteOriginal(rezago.codigo_ORDEN_FLETE_ORIGINAL);


                let largo: string = "" + rezago.motivo_REZAGO.trim().length;
                setLargoMotivo(largo);

                let motivo: string = "" + rezago.motivo_REZAGO;


                if (selectorAccionInfo == "null") {
                    if (motivo != null) {
                        if (motivo != "No ingreso Orden de Flete") {
                            forzarEstadoRezago();
                            forzarOFTieneRTezago();
                        } else { }
                    } else { }
                } else { }
            } else {

                setOrdeFleteRezago("");
                setDiasRezago("");
                setMotivoRezago("");
                setOrdeFleteOriginal("");
                setLargoMotivo("0");

                const forzar = async () => {
                    await setEnableViewRezago(false);
                    await setOFTieneRTezago(false);
                };

                await forzar();

            }

        } catch (e) {

            setOrdeFleteRezago(MensajeRezago);
            setDiasRezago(MensajeRezago);
            setMotivoRezago(MensajeRezago);
            setOrdeFleteOriginal(MensajeRezago);
            setLargoMotivo("0");

            const forzar = async () => {
                await setEnableViewRezago(false);
                await setOFTieneRTezago(false);
            };

            await forzar();
        }

    }

    async function cargaModalRezago(encacodigobarra: string) {

        let ejecutar: number = 0;

        let enca = encacodigobarra;

        if (encacodigobarra != null) {

            try {

                let rezago = await traeRezago(enca);

                setOrdenFleteRezago2(rezago.codigo_ORDEN_FLETE_REZAGO);
                setDiasRezago2(rezago.dias_REZAGO);
                setMotivoRezago2(rezago.motivo_REZAGO.trim());
                setOrdenFleteOriginal2(rezago.codigo_ORDEN_FLETE_ORIGINAL);

                let largo: string = "" + rezago.motivo_REZAGO.trim().length;

                setLargoMotivo2(largo);

                if (rezago != null && rezago.motivo_REZAGO != "-1") {
                    ejecutar = 1;
                    setShow2(true);


                } else {
                    setLargoMotivo2("0");
                    setMotivoRezago2("");
                    setDiasRezago2("");
                    setOrdenFleteOriginal2("");
                    setOrdenFleteRezago2("");

                }

                return ejecutar;

            } catch (e) { return ejecutar; }

        }
    }

    const forzarEstadoRezago = () => {

        const StateForzadoInicio = () => {
            return setEnableViewRezago(true);
        }

        StateForzadoInicio();

    }

    async function cargaEncargos(OrdenFlete: any) {

        let Encars: any[] = [];

        if (OrdenFlete != "No hay Of Relacionada") {

            let datos: any = await TrackingDetalle(OrdenFlete);

            let DATA = datos.data;



            let fechaCom = DATA.ordenFlete.fechaCompromiso;

            if (fechaCom != null) {
                let ArrayFecha = DATA.ordenFlete.fechaCompromiso.split("T");
                setFechaComprmiso(ArrayFecha[0]);

            } else if (fechaCom != "") {
                setFechaComprmiso("Sin Fecha Compromiso");
            } else {
                setFechaComprmiso("Sin Fecha Compromiso");
            }

            setEstadoProcesoCodigo(DATA.ordenFlete.codigoEstado);

            let encargos = DATA.encargos;

            if (encargos.length != 0) {

                let en = encargos[0];

                setEncaCodigoBarra(en.encargoCodigoBarra);

                let enc: {} = {

                    encargo: en.encargoCodigoBarra,
                    button: <Button className="mt-1 md-1" type="primary" style={{ color: Color_Blanco, backgroundColor: Color_Verde }} onClick={() => { DelaySeg(0.1); setShow1(true); }}> Recuperar Bulto Ciego </Button>
                }

                Encars.push(enc);

                setArrayEncargos(Encars);

                await cargaRezago(en.encargoCodigoBarra);

            } else {

                await cargaRezagoOF(OrdenFlete);

                setEnableViewGestionar(true);

            }
        }
    };

    const columns = [
        {
            name: "Encargo",
            selector: (row: any) => row.encargo
        },
        {
            name: "Acción",
            selector: (row: any) => row.button
        }

    ];

    const columnsOriginal = [
        {
            name: "#",
            compact: true,
            selector: (row: any) => row.index
        },
        {
            name: "Encargo",
            grow: 2,
            center: true,
            compact: true,
            selector: (row: any) => row.encargo
        },
        {
            name: "Estado",
            compact: true,
            center: true,
            grow: 1,
            selector: (row: any) => row.estadoEncargo

        },
        {
            name: "Acción",
            compact: true,
            center: true,
            grow: 1,
            selector: (row: any) => row.button
        }

    ];

    function Button2() {

        const [showMessage, setShowMessage] = useState(false);

        return (
            <div>
                <button onClick={() => setShowMessage(!showMessage)}>
                    Mostrar/Ocultar mensaje
                </button>
                {showMessage && <p>Mensaje oculto</p>}
            </div>
        );
    }


    // funcion que ordena la carga de datos
    async function ordenDeCarga(modalInfoDto: ModalInfo) {
        CargaModalInfo(modalInfoDto);
    }



    async function CargaModalInfo(itemExt: ModalInfo) {

        // TRABAJO CAMPO OBSERVACIONES

        let datos = itemExt.obs;

        let arrayObs;

        if (ENTORNO.ENTORNO == "PRODUCCION" || ENTORNO.ENTORNO == "LOCAL_PRD") {
            arrayObs = datos.split("Observaciones");
        } else {
            arrayObs = datos.split("Observaciones");
        }

        let obs = arrayObs[1];

        let obsLimpia = CaracteresEspeciales(obs);

        modalInfoDto.obs = obsLimpia.toUpperCase();

        // TRABAJO FECHAS Y HORAS

        let hora = HoraCorrecta(itemExt.hora);

        modalInfoDto.hora = hora;

        let fecha = InvierteFecha(itemExt.fecha);

        modalInfoDto.fecha = fecha;



        modalInfoDto.creador = itemExt.creador;

        modalInfoDto.ticket = itemExt.ticket;

        // TRABAJO DE ORDEN DE FLETE

        modalInfoDto.ordenFlete = (itemExt.ordenFlete != "" || itemExt.ordenFlete != undefined || itemExt.ordenFlete != null || itemExt.ordenFlete != ".") ? itemExt.ordenFlete : "No hay Of Relacionada";

        modalInfoDto.sinOF = itemExt.sinOF;




        let Fechas: any;

        if (modalInfoDto.sinOF == "Si-Tiene") {

            Fechas = await CalculoFechaEnvioRezago(modalInfoDto.ordenFlete);

            if (Fechas.creacion == "Problemas con OF") {
                setAlertaOf(true);
            }

            modalInfoDto.fechaEnvioRezago = (itemExt.ordenFlete != "" || itemExt.ordenFlete != undefined || itemExt.ordenFlete != null || itemExt.ordenFlete != ".") ? Fechas.rezago : "No se Puede Calcular Fecha";

            modalInfoDto.fechaCreacionOf = (itemExt.ordenFlete != "" || itemExt.ordenFlete != undefined || itemExt.ordenFlete != null || itemExt.ordenFlete != ".") ? Fechas.creacion : "No se Puede Calcular Fecha";
        }

        modalInfoDto.color = (itemExt.color != "") ? itemExt.color : "No hay Clasificacion de Color";

        modalInfoDto.tipoTicket = itemExt.tipoTicket;

        let largo = itemExt.imagenes.length;

        let array: any[] = []

        if (largo > 0) {

            try {

                itemExt.imagenes.map((item: any, index: any) => {

                    array.push(<Image width={150} src={item} fallback={NoImage} alt={'Image' + index + random} key={'Image' + index + random} />);

                    return null;
                });
            } catch (e) { }

        } else {
            array.push(<Image width={150} src={NoImage} fallback={NoImage} alt={'Image' + random} key={'Image' + random} />);
        }

        modalInfoDto.imagenes = array;

        modalInfoDto.largoObs = (modalInfoDto.obs.length != 0) ? "" + modalInfoDto.obs.length : "0";

        modalInfoDto.ticketRecuperadoPOR = "";
        modalInfoDto.ticketRecuperado = "";

        modalInfoDto.agencia = itemExt.agencia;



        setModalInfoDto({ ...modalInfoDto })

        setShowU(false);


        if (modalInfoDto.sinOF == "Si-Tiene") {

            await cargaEncargos(modalInfoDto.ordenFlete);

        }


        setShowU(false);

        if (modalInfoDto.sinOF == "No-Tiene") {




            setEnableViewSinOf(true);



        } else {



            setEnableViewSinOf(false);

        }


        setShowU(false);

        setShow(true);



    }


    async function BusquedaConcentrada(tipo: any) {


        // @ts-ignore
        if (checkedSucursal == true
            || checkedColor == true
            || checkedTipoTicket == true
            || checkedRangoFecha == true
            || checkedPalabraClave == true
        ) {


            //  busquedaOmni();
            busquedaOmniCiente();

        } else {
            if (tipo == "sucursal") {

                busquedaSucursal(idSucursal);
                await DelaySeg(1);

            } else if (tipo == "color") {

                busquedaColor(idColor);
                await DelaySeg(1);

            } else if (tipo == "tipoticket") {

                busquedaTipoTicket(idTipoTicket);
                await DelaySeg(1);

            } else if (tipo == "fecha") {

                busquedaFecha();
                await DelaySeg(1);

            } else {
                busquedaPalabra();
            }
        }
    }

    async function busquedaSucursal(id: string) {

        setShowU(true);
        cambiaMensaje();

        images.length = 0;

        let fecha = await CalcularFechaAnterior();



        const sucursales: any[] = await Topdesk.BusquedaSucursalFiltrada(id, fecha).then(async (resp) => {

            if (resp.error) {

                AlertaCentral("ERROR");
                setShowU(false);

            } else {


                let largo = await resp.data;

                if (largo.length > 0) {

                    return resp.data;
                } else {
                    setShowU(false);
                    AlertaCentral("NOBULTOCIEGO");
                }
            }
        });

        // let sucursales_finales: any[] = await LimpiaResultados(sucursales);


        if (checkedSucursal == false) {

            let respues = await ValidacionesPrevias(sucursales);

            await construirGaleria(respues);
        } else {
            return sucursales;
        }


    }

    async function busquedaColor(id: string) {

        setShowU(true);
        cambiaMensaje();

        images.length = 0;

        let fecha = await CalcularFechaAnterior();
        const sucursales: any[] = await Topdesk.BusquedaColorFiltrada(id, fecha).then(async (resp) => {

            if (resp.error) {

                AlertaCentral("ERROR");
                setShowU(false);

            } else {

                let largo = await resp.data;

                if (largo.length > 0) {

                    return resp.data;
                } else {
                    setShowU(false);
                    AlertaCentral("NOBULTOCIEGOCOLOR");
                }
            }


        });



        if (checkedColor == false) {


            let respues = await ValidacionesPrevias(sucursales);

            await construirGaleria(respues);


        } else {

            return sucursales;
        }

    }

    async function busquedaTipoTicket(id?: string) {

        setShowU(true);
        cambiaMensaje();

        images.length = 0;

        let fecha = await CalcularFechaAnterior();

        const sucursales: any[] = await Topdesk.BusquedaTipoTicketFiltrada(id, fecha).then(async (resp) => {

            if (resp.error) {

                AlertaCentral("ERROR");
                setShowU(false);

            } else {

                let largo = await resp.data;

                if (largo.length > 0) {

                    return resp.data;
                } else {
                    setShowU(false);
                    AlertaCentral("NOBULTOCIEGOMULTI");
                }
            }


            return resp.data;
        });

        if (checkedTipoTicket == false) {

            let respues = await ValidacionesPrevias(sucursales);

            await construirGaleria(respues);

        } else {

            return sucursales;
        }
    }

    async function busquedaFecha() {

        setShowU(true);
        cambiaMensaje();

        images.length = 0; // Limpia Galeria.


        let fechaOrdenada1 = OrdenaFechaServer(idFechaRango[0]);
        let fechaOrdenada2 = OrdenaFechaServer(idFechaRango[1]);


        const startDate = moment(fechaOrdenada1, 'YYYY-MM-DD');
        const endDate = moment(fechaOrdenada2, 'YYYY-MM-DD');




        const resultado = endDate.diff(startDate, 'days') + 1;

        let fechaInicio = formatoFechaQuery(fechaOrdenada1);
        let fechaFinal = formatoFechaQuery(fechaOrdenada2);


        setFechaInicio(fechaInicio);
        setFechaFinal(fechaFinal);

        // fechaInicio = "2023-07-04T";
        // fechaFinal = "2023-07-12T";


        let FechaActual = new Date();
        let FechaActualISO = FechaActual.toISOString();
        let ArrayFechaActual = FechaActualISO.split("T");
        let FechaActualFormateada = ArrayFechaActual[0];

        let mesesAnteriores = await CalcularSieteMesesAntes();


        let inicio2: any = new Date(mesesAnteriores);

        let final2: any = new Date(fechaOrdenada1)


        if (final2 > inicio2) {


            if (resultado > 15) {
                setShowU(false);
                AlertaCentral("DIASMAXIMOS")

            } else {

                let sucursales: any[] = [];

                if (fechaInicio != fechaFinal) {

                    sucursales = await Topdesk.BusquedaRangoFecha(fechaInicio, fechaFinal).then(async (resp) => {

                        if (resp.error) {
                            AlertaCentral("ERROR");
                            setShowU(false);
                        } else {

                            let largo = await resp.data;

                            if (largo.length > 0) {

                                return resp.data;
                            } else {


                                if (checkedRangoFecha == true) {

                                    return [];

                                } else {

                                    setShowU(false);
                                    AlertaCentral("NOTICKETRANGOFECHA");
                                }


                            }
                        }
                    });

                } else {



                    sucursales = await Topdesk.BusquedaRangoFechaUnica(fechaInicio).then(async (resp) => {



                        if (resp.error) {
                            AlertaCentral("ERROR");
                            setShowU(false);
                        } else {

                            let largo = await resp.data;

                            if (largo.length > 0) {

                                return resp.data;
                            } else {


                                if (checkedRangoFecha == true) {

                                    return [];

                                } else {

                                    setShowU(false);
                                    AlertaCentral("NOTICKETRANGOFECHA");
                                }


                            }
                        }
                    });
                }


                if (checkedRangoFecha == false) {


                    let respues = await ValidacionesPrevias(sucursales);

                    await construirGaleria(respues);

                } else {
                    return sucursales;
                }

            }
        } else {

            setShowU(false);
            AlertaCentral("RANGOFECHASUPERIOR");

        }

    }


    // TODO: 01 ESTO ES LO QUE SE NECESITA DESARROLLAR
    async function busquedaPalabra() {

        console.log("Busqueda palabra clave ");
        console.log("nombre Palabra", nombrePalabra);
        console.log("State REACT Nombre Palabra ", nombrePalabra);

        let vacio: any[] = []

        let sucursales: any[] = [];

        setShowU(true);
        cambiaMensaje();

        images.length = 0;

        if (checkedPalabraClave == false) {

            let Tickets: string = "";


            let observa: any[] = await Observaciones.BusquedaObs(nombrePalabra).then(async (resp) => {

                if (resp.error) {
                    AlertaCentral("ERROR");
                    setShowU(false);
                } else {

                    let largo = await resp.data.response;

                    if (largo.length > 0) {

                        return resp.data.response;
                    } else {
                        setShowU(false);
                        AlertaCentral("NOTICKETPALABRACLAVE");
                    }
                }
            });


            // console.log("observa ", observa);


            if (observa != undefined) {

                Tickets = await contruyeStringConsulta(observa);

                // console.log("Tickets ->", Tickets);

                sucursales = await Topdesk.busquedaFiltradaOBS(Tickets).then(async (resp: any) => {

                    if (resp.error) {

                        AlertaCentral("ERROR");
                        setShowU(false);

                    } else {


                        let largo = await resp.data;

                        if (largo.length > 0) {

                            return resp.data;
                        } else {
                            setShowU(false);
                            AlertaCentral("NOBULTOCIEGO");
                        }
                    }
                });

                // console.log("sucursales ", sucursales);

                let respues = await ValidacionesPrevias(sucursales); // TODO: AQUI VOY

                await construirGaleria(respues);

            } else {
                return sucursales;
            }
        } else {





            return sucursales;
        }

    }

    async function busquedaOmniCiente() {

        setShowU(true);

        images.length = 0; // Limpia Galeria.

        let resp: any[] = [];


        let Texto = "";

        let Tickets = "";

        if (checkedPalabraClave == true) {

            console.log("seleccione palabra clave debo operar sobre api obs");

            console.log("Palabra Clave ", nombrePalabra);

            let Sucursal: any = null;

            let Color: any = null;

            let Tipo: any = null;

            let RangoFecha: any = null;

            if (checkedSucursal == true) {

                console.log("Seleccioné una sucursal");
                Sucursal = idSucursal;
                console.log(Sucursal);
            }

            if (checkedColor == true) {

                console.log("Seleccioné un color ");
                Color = idColor.trim();
                console.log(Color);

            }

            if (checkedTipoTicket == true) {
                console.log("Seleccioné un tipo de tiket");
                Tipo = idTipoTicket;
                console.log("tipo ", Tipo);
            }

            if (checkedRangoFecha == true) {

                console.log("seleccioné un rango de fecha");

                console.log("idFechaRango[0]", idFechaRango[0]);

                if (idFechaRango[0] != undefined) {




                    let fechaOrdenada1: any = OrdenaFechaServer(idFechaRango[0]);
                    let fechaOrdenada2: any = OrdenaFechaServer(idFechaRango[1]);

                    console.log("fechas ", fechaOrdenada1, "T", fechaOrdenada2);

                    let Inicio: any = new Date(fechaOrdenada1);
                    let Final: any = new Date(fechaOrdenada2);

                    let diff: any = Final - Inicio;
                    let resultado: number = await diff / (1000 * 60 * 60 * 24);

                    let fechaInicio = formatoFechaQuery(fechaOrdenada1);
                    let fechaFinal = formatoFechaQuery(fechaOrdenada2);

                    setFechaInicio(fechaInicio);
                    setFechaFinal(fechaFinal);


                    let mesesAnteriores = await CalcularSieteMesesAntes();

                    let inicio2: any = new Date(mesesAnteriores);

                    let final2: any = new Date(fechaOrdenada1)





                    if (final2 > inicio2) {

                        if (resultado > 15) {


                            console.log("Me pase de los 15 dias");

                            setShowU(false);
                            AlertaCentral("DIASMAXIMOS2");

                        } else {

                            let fecha: string = `${fechaInicio.slice(0, -1)}T${fechaFinal.slice(0, -1)}`;

                            RangoFecha = fecha;
                        }

                    } else {

                        console.log("ingrese mal las fechas");

                        setShowU(false);
                        AlertaCentral("RANGOFECHASUPERIOR2");

                    }

                } else {
                    setShowU(false);
                    AlertaCentral("RANGOFECHASUPERIOR3");
                }
            }

            let observa = await Observaciones.BusquedaObs(nombrePalabra, Sucursal, Color, Tipo, RangoFecha).then(async (resp: any) => {
                if (resp.error) {
                    AlertaCentral("ERROR");
                    setShowU(false);
                } else {

                    let largo = await resp.data.response;

                    if (largo.length > 0) {

                        return resp.data.response;
                    } else {
                        setShowU(false);
                        AlertaCentral("NOTICKETPALABRACLAVE");
                    }
                }

            });

            console.log("observa ", observa);


            if (observa != undefined) {

                Tickets = await contruyeStringConsulta(observa);

                console.log("Tickets ->", Tickets);

                let sucursales = await Topdesk.busquedaFiltradaOBS(Tickets).then(async (resp: any) => {

                    if (resp.error) {

                        AlertaCentral("ERROR");
                        setShowU(false);

                    } else {


                        let largo = await resp.data;

                        if (largo.length > 0) {

                            return resp.data;
                        } else {
                            setShowU(false);
                            AlertaCentral("NOBULTOCIEGO");
                        }
                    }
                });

                console.log("sucursales ", sucursales);

                let respues = await ValidacionesPrevias(sucursales);


                console.log("respues", respues);

                await construirGaleria(respues);

            } else {

            }

            setShowU(false);

        } else {


            if (checkedSucursal == true) {

                Texto = Texto + `;caller.branch.id==${idSucursal}`;
            }


            if (checkedColor == true) {

                Texto = Texto + `;optionalFields1.searchlist4.id==${idColor}`;

            }


            if (checkedTipoTicket == true) {

                Texto = Texto + `;optionalFields2.searchlist2.id==${idTipoTicket}`;

            }

            if (checkedRangoFecha == true) {

                let fechaOrdenada1 = OrdenaFechaServer(idFechaRango[0]);
                let fechaOrdenada2 = OrdenaFechaServer(idFechaRango[1]);

                let Inicio: any = new Date(fechaOrdenada1);
                let Final: any = new Date(fechaOrdenada2);

                let diff: any = Final - Inicio;
                let resultado: number = await diff / (1000 * 60 * 60 * 24);

                let fechaInicio = formatoFechaQuery(fechaOrdenada1);
                let fechaFinal = formatoFechaQuery(fechaOrdenada2);

                setFechaInicio(fechaInicio);
                setFechaFinal(fechaFinal);

                let FechaActual = new Date();
                let FechaActualISO = FechaActual.toISOString();
                let ArrayFechaActual = FechaActualISO.split("T");
                let FechaActualFormateada = ArrayFechaActual[0];

                let mesesAnteriores = await CalcularSieteMesesAntes();

                let inicio2: any = new Date(mesesAnteriores);

                let final2: any = new Date(fechaOrdenada1)

                let fecha = await CalcularFechaAnterior();

                if (final2 > inicio2) {

                    if (resultado > 15) {

                        setShowU(false);
                        AlertaCentral("DIASMAXIMOS2");

                        Texto = Texto + `;creationDate=ge=${fecha}00:00:00Z`; // <-- este va siempre al final

                    } else {

                        Texto = Texto + `;creationDate=ge=${fechaInicio}00:00:00Z;creationDate=le=${fechaFinal}00:00:00Z`;
                    }

                } else {

                    setShowU(false);
                    AlertaCentral("RANGOFECHASUPERIOR2");

                    Texto = Texto + `;creationDate=ge=${fecha}00:00:00Z`; // <-- este va siempre al final

                }

            } else {

                let fecha = await CalcularFechaAnterior();

                Texto = Texto + `;creationDate=ge=${fecha}00:00:00Z`; // <-- este va siempre al final
            }

            resp = await Topdesk.BusquedaDinamica(Texto).then((resp: any) => {
                return resp.data;
            });

            let respues = await ValidacionesPrevias(resp);







            if (resp.length != 0) {

                await construirGaleria(respues);
                setShowU(false);

            } else {

                setShowU(false);

                AlertaCentral("NOBULTOCIEGOMULTI");

                images.length = 0;
            }

        }

    }

    async function crearTablaBultos(encargos: any) {

        let ArrayEnc: any[] = [];

        encargos.forEach((encargo: any, index: any) => {

            let estadoProceso = encargo.estadoProceso.trim();

            let button;

            if (estadoProceso == "ENTREGADO") {

                button = <Button className="mt-1 md-1" type="primary" disabled style={{ color: Color_Verde, backgroundColor: Color_Blanco }} > Seleccionar {" "} &nbsp;  <FontAwesomeIcon icon={faBox} /> </Button>;
            } else {
                button = <Button className="mt-1 md-1"
                    type="primary"
                    style={{ color: Color_Blanco, backgroundColor: Color_Verde }}
                    onClick={() => { DelaySeg(0.1); encargoSeleccionado(encargo.encargoCodigoBarra, index + 1) }}>
                    Seleccionar {" "} &nbsp;
                    <FontAwesomeIcon icon={faBox} />
                </Button>;
            }

            let enc = {
                index: index + 1,
                encargo: encargo.encargoCodigoBarra,
                estadoEncargo: estadoProceso,
                button: button
            }

            ArrayEnc.push(enc);

        });


        let largo = ArrayEnc.length;

        if (largo > 1) {
            setArrayEncargosOriginales(ArrayEnc);
            setShow3(true); // AQUI ABREMODAL QUE PERMITE CONTINUAR

            return 1;
        } else {

            return 0;
        }

    }

    async function encargoSeleccionado(encargo: any, index: any) {

        setEncargoSeleccionado(encargo);
        setIndexEncargoSeleccionado(index);
        setESBoton(true)

    }

    async function AccionIngresarOfOriginal(modalInfoDto: ModalInfo) {

        forzarIsOriginal();

        setProgress(true);

        let OF_BULTO_CIEGO: number = Number(modalInfoDto.ordenFlete);

        let OF_INGRESADA: number = Number(oFOrifinal);

        if (oFOrifinal.length > 0) {                                        // VERIFICA OF INGRESADA NO VACIA 

            if (OF_BULTO_CIEGO != OF_INGRESADA) {                           // VERIFICA QUE LA OF INGRESADA NO SEA LA MISMA DEL TICKET  

                setnumeroAPI(6);
                setnomColor("primary");

                setCargaBarra(15);

                let datos: any = await TrackingDetalle(OF_INGRESADA);       // TRAE DATOS DE LA OF INGRESADA DESDE TRACKING DETALLE

                let error = datos.error;

                if (error === undefined) {

                    if (datos.data.ordenFlete.of != null) {                 // VERIFICA SI LA OF EXISTE EN EL SISTEMA

                        setRespuestaSegundaParte(datos);                    // MANDO LOS DATOS DE LA OF INGRESADA A LA SEGUNDA PARTE

                        let Encargos: any[] = datos.data.encargos;

                        let llaveEncargos: number = await crearTablaBultos(Encargos); // SI LA LLAVE TIENE SOLO 1 ENCARGO CONTINUA SINO MANDA A SEGUNDA PARTE

                        if (llaveEncargos != 0) {

                        } else {

                            let encargo: any | undefined = datos.data.encargos[0]?.encargoCodigoBarra;


                            if (encargo != undefined) {

                                ForzarDatosOriginales(datos.data.encargos[0].encargoCodigoBarra, datos.data.ordenFlete.codigoEstado, datos.data.ordenFlete.fechaCompromiso);

                                if (await validarOf(datos)) {

                                    setnumeroAPI(4);
                                    setnomColor("primary");
                                    setCargaBarra(45);

                                    let estadosValidos: any = await validarEstado(datos);

                                    if (estadosValidos.booleano) {

                                        setnumeroAPI(3);
                                        setnomColor("HOLA");
                                        setCargaBarra(65);

                                        let valtop: boolean = (await validarTopdeskOfOriginal(OF_INGRESADA, modalInfoDto.ticket)).validador;

                                        if (valtop == true) {
                                            setShowU(false);

                                            let modal = await cargaModalRezago(datos.data.encargos[0].encargoCodigoBarra);

                                            if (modal === 0) {



                                                setnumeroAPI(2);
                                                setnomColor("primary");

                                                setCargaBarra(80);


                                                OpenForm(modalInfoDto);

                                            } else {
                                                setAccionRezago(true);
                                            }
                                        } else {
                                            setShowU(false);
                                            AlertaCentral("OFCONTICKET", "", "", "" + OF_INGRESADA, (await validarTopdeskOfOriginal(OF_INGRESADA, modalInfoDto.ticket)).mensaje);
                                        };
                                    } else {
                                        setShowU(false);
                                        AlertaCentral("OFNOALTERABLE", "", "", estadosValidos.mensaje + OF_BULTO_CIEGO);
                                    }
                                } else {
                                    setShowU(false);
                                    AlertaCentral("OFNOEXISTE", "", "", "" + OF_INGRESADA);
                                }



                            } else {

                                let estadosValidos: any = await validarEstado(datos);

                                AlertaCentral("OFORIREDESTINADA", "", "", estadosValidos.mensaje);

                            }

                        }
                    } else {
                        setShowU(false);
                        AlertaCentral("OFNOEXISTE", "", "", "" + OF_INGRESADA);
                    }

                    setShowU(false);
                } else {
                    setShowU(false);
                    AlertaCentral("OFBULTOCIEGO", "", "", "" + OF_INGRESADA);
                }
            } else {
                setShowU(false);
                AlertaCentral("DEBEINGRESAROF");
            }
        }
    }

    async function SegundaParteOfOriginal(resp: any) {

        let OF_INGRESADA: number = Number(oFOrifinal);

        setShow3(false);

        ForzarDatosOriginales(EncargoSeleccionado, resp.data.ordenFlete.codigoEstado, resp.data.ordenFlete.fechaCompromiso);

        await DelaySeg(1);

        if (await validarOf(resp)) {

            setnumeroAPI(4);
            setnomColor("primary");
            setCargaBarra(45);


            if (await validarEstado(resp)) {

                setnumeroAPI(3);
                setnomColor("HOLA");
                setCargaBarra(65);

                let valtop: boolean = (await validarTopdeskOfOriginal(OF_INGRESADA, modalInfoDto.ticket)).validador;

                if (valtop == true) {
                    setShowU(false);

                    let modal = await cargaModalRezago(EncargoSeleccionado);

                    if (modal === 0) {

                        setnumeroAPI(2);
                        setnomColor("primary");

                        setCargaBarra(80);

                        OpenForm(modalInfoDto);

                    } else {
                        setAccionRezago(true);
                    }
                } else {
                    setShowU(false);
                    AlertaCentral("OFCONTICKET", "", "", "" + OF_INGRESADA, (await validarTopdeskOfOriginal(OF_INGRESADA, modalInfoDto.ticket)).mensaje);
                };

            } else {
                setShowU(false);
                AlertaCentral("OFNOALTERABLE", "", "", "" + OF_INGRESADA);
            }
        } else {
            setShowU(false);
            AlertaCentral("OFNOEXISTE", "", "", "" + OF_INGRESADA);
        }

    }


    async function AccionIngresarOfTicket(modalInfoDto: ModalInfo) {

        sessionStorage.removeItem('DatosOriginales');

        setProgress(true);
        setShowU(true);

        try {

            if (modalInfoDto.ordenFlete != `No hay Of Relacionada`) {

                let OF_BULTO_CIEGO: number = Number(modalInfoDto.ordenFlete);

                setnumeroAPI(6);
                setnomColor("primary");

                setCargaBarra(15);

                let datos: any = await TrackingDetalle(OF_BULTO_CIEGO);

                setnumeroAPI(5);
                setnomColor("primary");
                setCargaBarra(24);

                let error = datos.error;

                if (error === undefined) {

                    if (datos.data.ordenFlete.of != null) {

                        if (await validarOf(datos)) {

                            setnumeroAPI(4);
                            setnomColor("primary");
                            setCargaBarra(45);

                            let estadosValidos: any = await validarEstado(datos);

                            if (estadosValidos.booleano) {

                                setnumeroAPI(3);
                                setnomColor("HOLA");
                                setCargaBarra(65);

                                let valtop: boolean = (await validarTopdeskOfTicket(OF_BULTO_CIEGO, modalInfoDto.ticket)).validador;
                                if (valtop == true) {
                                    setShowU(false);
                                    setnumeroAPI(2);
                                    setnomColor("primary");
                                    setCargaBarra(80);
                                    OpenForm(modalInfoDto);
                                } else {
                                    setShowU(false);
                                    let mensaje: string = (await validarTopdeskOfTicket(OF_BULTO_CIEGO, modalInfoDto.ticket)).mensaje;
                                    AlertaCentral("OFCONTICKET", "", "", "" + OF_BULTO_CIEGO, mensaje);
                                };
                            } else {
                                setShowU(false);
                                AlertaCentral("OFNOALTERABLE", "", "", estadosValidos.mensaje + OF_BULTO_CIEGO);
                            }
                        } else {
                            setShowU(false);
                            AlertaCentral("OFNOEXISTE", "", "", "" + OF_BULTO_CIEGO);
                        }
                    } else {
                        setShowU(false);
                        AlertaCentral("OFNOEXISTE", "", "", "" + OF_BULTO_CIEGO);
                    }
                } else {
                    setShowU(false);
                    AlertaCentral("OFNOEXISTE", "", "", "" + OF_BULTO_CIEGO);
                }
                setShowU(false);
            } else {
                setShowU(false);
                AlertaCentral("TICKETOFMALA", "", "", "");
            }
        } catch (e) { }
    }


    // SE BASA EN CATEGORIA
    async function SeleccionAccionInfo(modalInfoDto: ModalInfo) {

        let clase: string = "" + modalInfoDto.categoria;

        let forzado = async () => {

            await setselectorAccionInfo(clase);

        };

        setTimeout(async () => {
            await forzado();
        }, 25);

    };



    async function FuncionFinal(modalInfoDto: ModalInfo) {

        let url: string = URL_ENVIO_FOMULARIO.URL_ENVIO_FOMULARIO;

        // TICKET
        let OrdenDeFlete: string = (modalInfoDto.ordenFlete != "" && modalInfoDto.ordenFlete != null) ? modalInfoDto.ordenFlete : "Sin Datos";                                      // asigna of de ticket de forma nativa
        let estadoProceso: number = (Number(EstadoProcesoCodigo) != 0 && Number(EstadoProcesoCodigo) != null) ? Number(EstadoProcesoCodigo) : -1;
        let CodigoEncargo: string = (EncaCodigoBarra != "" && EncaCodigoBarra != null) ? EncaCodigoBarra : "Sin Datos";
        let fechacompro: string = (FechaComprmiso != "" && FechaComprmiso != null) ? FechaComprmiso : "Sin Datos";

        let NumeroTicketFINAL: string = modalInfoDto.ticket;


        let Original_OrdenFleteRezago2: string = (OrdenFleteRezago2 != "" && OrdenFleteRezago2 != null) ? OrdenFleteRezago2 : "Sin Datos";
        let Original_DiasRezago2: string = (DiasRezago2 != "" && DiasRezago2 != null) ? DiasRezago2 : "Sin Datos";
        let Original_MotivoRezago2: string = (MotivoRezago2 != "" && MotivoRezago2 != null) ? MotivoRezago2 : "Sin Datos";
        let Original_OrdenFleteOriginal2: string = (OrdenFleteOriginal2 != "" && OrdenFleteOriginal2 != null) ? OrdenFleteOriginal2 : "Sin Datos";

        setnumeroAPI(1);
        setnomColor("primary");

        try {

            const Datos = sessionStorage.getItem("DatosOriginales");

            let DatoUtil;

            if (Datos) {
                const DatosUtiles = JSON.parse(Datos);
                DatoUtil = DatosUtiles;
            }

            // ORIGINAL
            let OrdenFleteOriginalFINAL: string = (oFOrifinal != "" && oFOrifinal != null) ? oFOrifinal : "Sin Datos";

            //UBICACION FISICA 

            let UFI_ticket: any = await TraeUbicacionFisica(CodigoEncargo, estadoProceso, fechacompro);

            // UBICACION FISICA ORIGINAL

            let EncacodigoBarraOriginal: string = "Sin Datos";
            let DentroPlazo_original: string = "Sin Datos";
            let EstadoEncargo_original: string = "Sin Datos";
            let NombreUbicacionFisica_original: string = "Sin Datos";


            if (OrdenFleteOriginalFINAL != "Sin Datos") {

                EncacodigoBarraOriginal = DatoUtil.EncaCodigoBarra.trim()

                let UFI_original: any = await TraeUbicacionFisica(DatoUtil.EncaCodigoBarra, DatoUtil.EstadoProcesoCodigo, DatoUtil.FechaCompromiso);

                DentroPlazo_original = (String(UFI_original.dentroPlazo) != "" && String(UFI_original.dentroPlazo) != null) ? String(UFI_original.dentroPlazo) : "Sin Datos";
                EstadoEncargo_original = (String(UFI_original.estadoEncargo) != "" && String(UFI_original.estadoEncargo) != null) ? String(UFI_original.estadoEncargo) : "Sin Datos";
                NombreUbicacionFisica_original = (String(UFI_original.nombre_ubicacion_fisica) != "" && String(UFI_original.nombre_ubicacion_fisica) != null) ? String(UFI_original.nombre_ubicacion_fisica) : "Sin Datos";

            }


            setCargaBarra(90);

            let DentroPlazo_ticket: string = String(UFI_ticket.dentroPlazo);
            let EstadoEncargo_ticket: string = String(UFI_ticket.estadoEncargo);
            let NombreUbicacionFisica_ticket: string = String(UFI_ticket.nombre_ubicacion_fisica);


            await DelaySeg(1);

            let envioFormulario = {                                                 //  Variable url para FORMULARIO TOPDESK              

                "ticket": {
                    "ordenFlete_ticket": OrdenDeFlete,                           //  odfl
                    "codigoEncargo_ticket": CodigoEncargo,                       //  encargo     
                    "dentro_plazo_ticket": DentroPlazo_ticket,                   //  dentroplazo
                    "estadoEncargo_ticket": EstadoEncargo_ticket,                //  estado
                    "ubicacionFisica_ticket": NombreUbicacionFisica_ticket,      //  ubicacion
                    "rezago": {
                        "ORDEN_FLETE": OrdenFleteRezago,                         //  ordenfleterezago
                        "DIAS_REZAGO": DiasRezago,                               //  diasrezago
                        "MOTIVO_REZAGO": MotivoRezago,                           //  motivorezago
                        "ORDEN_FLETE_ORIGINAL": OrdenFleteOriginal,              //  ordenfleteoriginalrezago                                 
                    }
                },

                "original": {
                    "ordenFlete_Original": OrdenFleteOriginalFINAL,              //  odfloriginal
                    "codigoEncargo_Original": EncacodigoBarraOriginal,           //  encargooriginal   ESTE NO EXISTE AUN   

                    "03_dentro_plazo_Original": DentroPlazo_original,
                    "04_estadoEncargo_Original": EstadoEncargo_original,
                    "05_ubicacionFisica_Original": NombreUbicacionFisica_original,

                    "06_rezago": {

                        "01_ORDEN_FLETE": Original_OrdenFleteRezago2,
                        "02_DIAS_REZAGO": Original_DiasRezago2,
                        "03_MOTIVO_REZAGO": Original_MotivoRezago2,
                        "04_ORDEN_FLETE_ORIGINAL": Original_OrdenFleteOriginal2,
                    }
                },
                "numeroTicket_ticket": NumeroTicketFINAL,                               // ticketbc                    
                "EsOriginal": IsOriginal,                                               // oforiginalb la original es OFOriginal
                "OfTieneRezago": OFTieneRTezago                                         // oftienerezagob

            }


            switch (VariablePaso) {

                case "original":

                    url += "&odfl=" + envioFormulario.ticket.ordenFlete_ticket;
                    url += "&encargo=" + envioFormulario.ticket.codigoEncargo_ticket;
                    url += "&dentroplazo=" + envioFormulario.ticket.dentro_plazo_ticket;
                    url += "&estado=" + envioFormulario.ticket.estadoEncargo_ticket;
                    url += "&ubicacion=" + envioFormulario.ticket.ubicacionFisica_ticket;

                    url += "&odfloriginal=" + envioFormulario.original.ordenFlete_Original;
                    url += "&encargooriginal=" + envioFormulario.original.codigoEncargo_Original;

                    url += "&ticketbc=" + envioFormulario.numeroTicket_ticket;
                    url += "&oforiginalb=true";
                    url += "&oftienerezagob=" + envioFormulario.OfTieneRezago;

                    if (OFTieneRTezago) {

                        url += "&ordenfleterezago=" + await SinDatos(envioFormulario.ticket.rezago.ORDEN_FLETE);
                        url += "&diasrezago=" + await SinDatos(envioFormulario.ticket.rezago.DIAS_REZAGO);
                        url += "&motivorezago=" + await SinDatos(envioFormulario.ticket.rezago.MOTIVO_REZAGO);
                        url += "&ordenfleteoriginalrezago=" + await SinDatos(envioFormulario.ticket.rezago.ORDEN_FLETE_ORIGINAL);

                    }

                    break;
                default:


                    url += "&odfl=" + envioFormulario.ticket.ordenFlete_ticket;
                    url += "&encargo=" + envioFormulario.ticket.codigoEncargo_ticket;
                    url += "&dentroplazo=" + envioFormulario.ticket.dentro_plazo_ticket;
                    url += "&estado=" + envioFormulario.ticket.estadoEncargo_ticket;
                    url += "&ubicacion=" + envioFormulario.ticket.ubicacionFisica_ticket;

                    url += "&ticketbc=" + envioFormulario.numeroTicket_ticket;
                    url += "&oforiginalb=false";
                    url += "&oftienerezagob=" + envioFormulario.OfTieneRezago;


                    if (OFTieneRTezago) {

                        url += "&ordenfleterezago=" + await SinDatos(envioFormulario.ticket.rezago.ORDEN_FLETE);
                        url += "&diasrezago=" + await SinDatos(envioFormulario.ticket.rezago.DIAS_REZAGO);
                        url += "&motivorezago=" + await SinDatos(envioFormulario.ticket.rezago.MOTIVO_REZAGO);
                        url += "&ordenfleteoriginalrezago=" + await SinDatos(envioFormulario.ticket.rezago.ORDEN_FLETE_ORIGINAL);

                    }
                    break;
            }

            return url;

        } catch (e) {

            return url;
        }



    }

    // TODO: DESCOMENTAR ANTES DE BUILD
    async function OpenForm(modalInfoDto: ModalInfo) {

        let URL = await FuncionFinal(modalInfoDto);

        console.log(URL);
        console.log(URL.length);

        await abrirFormulario(URL);

        setnumeroAPI(0);
        setnomColor("primary");

        setCargaBarra(100);

    }



    async function cargaDatosTicketRecuperado(modalInfoDto: any) {




        try {

            if (modalInfoDto.ticketRecuperado != "") {

                let Datos = await traeTicketResuelto(modalInfoDto);

                let TicketRecu = Datos.number;

                let AgenteRecu = Datos.requester.name;

                let ofRecu: any | null | undefined = Datos.optionalFields1.text1;

                let ofTicket: any | null | undefined = Datos.optionalFields2.text1;

                let ofRecuperada = ofTicket;

                if (ofRecu != "") {
                    ofRecuperada = ofRecu;
                }

                let ejecutar = async () => {

                    setrecuperacionTicket(TicketRecu);
                    setrecuperacionAgente(AgenteRecu);
                    setrecuperacionOrdenFlete(ofRecuperada);
                }

                await ejecutar();

            } else {

                if (modalInfoDto.sinOF == "Si-Tiene") {

                    let ofe: any = modalInfoDto.ordenFlete;

                    let ejecutar = async () => {

                        setrecuperacionTicket("");
                        setrecuperacionAgente("");
                        setrecuperacionOrdenFlete(ofe);
                    }

                    await ejecutar();

                } else {

                    let ejecutar = async () => {

                        setrecuperacionTicket("");
                        setrecuperacionAgente("");
                        setrecuperacionOrdenFlete("Sin Orden Flete");
                    }

                    await ejecutar();


                }
            }

            setShowU(false);
        } catch (e) { }
    }

    function ForzarDatosOriginales(enca: string, codproceso: string, fechaCompro: string) {

        sessionStorage.removeItem('DatosOriginales');

        let arrayFecha: any[] = fechaCompro.split("T");

        let EnCodiBar = enca;
        let EsProCo = codproceso;
        let FeCo = arrayFecha[0];

        let DatosOriginales = {

            EncaCodigoBarra: EnCodiBar,
            EstadoProcesoCodigo: codproceso,
            FechaCompromiso: FeCo

        }


        setEncaCodigoBarra2(EnCodiBar);
        setEstadoProcesoCodigo2(EsProCo);
        setFechaCompromiso2(FeCo);


        sessionStorage.setItem("DatosOriginales", JSON.stringify(DatosOriginales));


    }

    async function forzarOFTieneRTezago() {
        const ejecutar = async () => {
            await setOFTieneRTezago(true);
        }
        await ejecutar();
    }

    async function forzarIsOriginal() {

        const ejecutar = async () => {
            VariablePaso = "original";
            await setIsOriginal(true);
        }
        await ejecutar();

    }


    return (

        <ConfigProvider locale={esES}>

            <>
                {/* MENU */}
                <Menu titulo="Búsqueda Bulto Ciego" logo="" />




                {/* INFORMACION */}
                <Alert className="ml-1" show={mostrar} variant="success">
                    <Alert.Heading> Información </Alert.Heading>
                    <p>
                        El sistema de búsqueda de <b> Bulto Ciego </b> permite encontrar encargos mediante su identificación visual.
                    </p>
                    <p>Para lo cual diponibiliza una busqueda avanzada con distintos filtros de clasificación.</p>
                    <p>Una vez que se identifique correctamente el encargo, se pueden realizar 4 acciones para recuperarlo.</p>

                    <div className="d-flex justify-content-end">
                        <OverlayTrigger
                            placement="left"
                            overlay={<Tooltip id="overlay-example">Cerrar Información</Tooltip>}
                        >
                            <Button
                                className="outline-info"
                                onClick={() => { setMostrar(false) }}
                            >
                                <FontAwesomeIcon icon={faAngleUp} />
                            </Button>
                        </OverlayTrigger>
                    </div>
                </Alert>

                {!mostrar && (
                    <OverlayTrigger
                        placement="right"
                        overlay={<Tooltip id="overlay-example">Abrir Información</Tooltip>}
                    >
                        <Button
                            shape="circle"
                            onClick={() => setMostrar(true)}
                        >
                            <FontAwesomeIcon icon={faInfoCircle} />
                        </Button>
                    </OverlayTrigger>
                )}

                <hr style={{ color: Color_Verde }} />

                {/* // SELECCION DE BUSQUEDA */}

                <Container

                    fluid="xl"
                    className="rounded pt-3 pb-3 shadow"
                    style={{ background: Color_Main_BackGround }}
                >
                    <div className="text-center justify-content-center" >
                        <Row className="text-center justify-content-center">
                            <Col></Col>
                            <Col>
                                <Col>
                                    <CheckCircleOutlined style={{ color: Color_Verde, fontSize: "25px" }} />
                                </Col>
                                <Col>
                                    <h5 style={{ color: Color_Verde }} > Selección de filtros </h5>
                                </Col>
                            </Col>
                            <Col></Col>
                        </Row>
                    </div>

                    <div className=" border" style={{ background: Color_Blanco }}>

                        <Container fluid="xl" className="text-center mt-3" >
                            <Row className="row">
                                <Col>
                                    {checkedSucursal ?
                                        <Button type="primary"
                                            icon={<CheckCircleFilled />}
                                            style={{ color: Color_Blanco, backgroundColor: Color_Sucursales }}
                                            className="d-flex justify-content-center shadow"
                                            block
                                            onClick={() => {
                                                soloFrame1();
                                                setEleccion("sucursal");
                                                setTitulo("X Sucursal");
                                                setColor(Color_Sucursales);
                                            }}
                                        >
                                            Sucursal {" "}&nbsp;&nbsp;&nbsp;
                                            <b>{nombreSucursal}</b>
                                        </Button>
                                        :
                                        <Button type="primary"
                                            icon={<SearchOutlined />}
                                            style={{ color: Color_Blanco, backgroundColor: Color_Sucursales }}
                                            className="d-flex justify-content-center shadow"
                                            block
                                            onClick={() => {
                                                soloFrame1();
                                                setEleccion("sucursal");
                                                setTitulo("X Sucursal");
                                                setColor(Color_Sucursales);
                                            }}
                                        >
                                            Sucursal {" "}&nbsp;&nbsp;&nbsp;

                                        </Button>
                                    }
                                </Col>
                                <Col>
                                    {checkedColor ?
                                        <Button type="primary"
                                            icon={<CheckCircleFilled />}
                                            style={{ color: Color_Blanco, backgroundColor: Color_Colores }}
                                            className="d-flex justify-content-center shadow"
                                            block
                                            onClick={() => {
                                                soloFrame2();
                                                setEleccion("color");
                                                setTitulo("X Color");
                                                setColor(Color_Colores)
                                            }}
                                        >
                                            Color {" "}&nbsp;&nbsp;&nbsp;
                                            <b>{nombreColors}</b>
                                        </Button>


                                        :
                                        <Button type="primary"
                                            icon={<SearchOutlined />}
                                            style={{ color: Color_Blanco, backgroundColor: Color_Colores }}
                                            className="d-flex justify-content-center shadow"
                                            block
                                            onClick={() => {
                                                soloFrame2();
                                                setEleccion("color");
                                                setTitulo("X Color");
                                                setColor(Color_Colores)
                                            }}
                                        >  Color {" "}&nbsp;&nbsp;&nbsp;
                                        </Button>

                                    }
                                </Col>
                                <Col>

                                    {checkedTipoTicket ?
                                        <Button type="primary"
                                            icon={<CheckCircleFilled />}
                                            style={{ color: Color_Blanco, backgroundColor: Color_Tickets }}
                                            className="d-flex justify-content-center shadow"
                                            block
                                            onClick={() => {
                                                soloFrame3();
                                                setEleccion("tipoticket");
                                                setTitulo("X Tipo Bulto");
                                                setColor(Color_Tickets)
                                            }}
                                        > Tipo Bulto  {" "}&nbsp;&nbsp;&nbsp;
                                            <b>{nombreTipoTk}</b>  </Button>
                                        :
                                        <Button type="primary"
                                            icon={<SearchOutlined />}
                                            style={{ color: Color_Blanco, backgroundColor: Color_Tickets }}
                                            className="d-flex justify-content-center shadow"
                                            block
                                            onClick={() => {
                                                soloFrame3();
                                                setEleccion("tipoticket");
                                                setTitulo("X Tipo Bulto");
                                                setColor(Color_Tickets)
                                            }}
                                        > Tipo Bulto  {" "}&nbsp;&nbsp;&nbsp;
                                        </Button>}


                                </Col>
                            </Row>
                        </Container>
                        <Container fluid="xl" className="text-center mt-3 mb-3">
                            <Row className="row">

                                <Col>
                                    {checkedRangoFecha ?
                                        <Button type="primary"
                                            icon={<CheckCircleFilled />}
                                            style={{ color: Color_Blanco, backgroundColor: Color_Fechas }}
                                            className="d-flex justify-content-center shadow"
                                            block
                                            onClick={() => {
                                                soloFrame4();
                                                setEleccion("fecha");
                                                setTitulo("X Randgo de Fechas");
                                                setColor(Color_Fechas)
                                            }}
                                        > Rango Fecha  {" "}&nbsp;&nbsp;&nbsp;
                                            <b>{nombreFecha}</b>  </Button>
                                        :
                                        <Button type="primary"
                                            icon={<SearchOutlined />}
                                            style={{ color: Color_Blanco, backgroundColor: Color_Fechas }}
                                            className="d-flex justify-content-center shadow"
                                            block
                                            onClick={() => {
                                                soloFrame4();
                                                setEleccion("fecha");
                                                setTitulo("X Randgo de Fechas");
                                                setColor(Color_Fechas)
                                            }}
                                        > Rango Fecha  {" "}&nbsp;&nbsp;&nbsp;
                                        </Button>}



                                </Col>

                                <Col>

                                    {checkedPalabraClave ?
                                        <Button type="primary"

                                            style={{ color: Color_Blanco, backgroundColor: Color_PalabrasClaves }}
                                            icon={<CheckCircleFilled />}
                                            className="d-flex justify-content-center shadow"
                                            block
                                            onClick={() => {
                                                soloFrame5();
                                                setTitulo("X Observaciones");
                                                setColor(Color_PalabrasClaves)
                                            }}
                                        > Palabra Clave {" "}&nbsp;&nbsp;&nbsp;
                                            <b>{nombrePalabra}</b>
                                        </Button>
                                        :
                                        <Button type="primary"
                                            icon={<SearchOutlined />}
                                            style={{ color: Color_Blanco, backgroundColor: Color_PalabrasClaves }}
                                            className="d-flex justify-content-center shadow"
                                            block
                                            onClick={() => {
                                                soloFrame5();
                                                setTitulo("X Observaciones");
                                                setColor(Color_PalabrasClaves)
                                            }}
                                        > Palabra Clave {" "} &nbsp;

                                        </Button>}


                                </Col>
                                <Col></Col>
                            </Row>
                        </Container>
                    </div>

                    <Container>
                        <Col className="text-center mt-2 md-2 justify-content-center">
                            <Button
                                className="shadow"
                                style={{ color: Color_Limpieza, backgroundColor: Color_BackGround_Limpieza }}
                                onClick={() => {
                                    cancelar()
                                }}>
                                <SyncOutlined style={{ color: Color_Limpieza }} />
                                <b> Limpiar Busqueda </b>
                            </Button>
                        </Col>
                    </Container>


                </Container>


                {/* // FRAME DE BUSQUEDA */}

                <Container
                    fluid="xl"
                    className="rounded mt-3 pt-3 pb-3  shadow"
                    style={{ background: Color_Main_BackGround }}
                >
                    <div className="text-center justify-content-center">
                        <Row className="row justify-content-center">
                            <Col></Col>
                            <Col>
                                <Col>
                                    <QuestionCircleOutlined style={{ color: Color_Verde, fontSize: "25px" }} />
                                </Col>
                                <Col>
                                    <h5 style={{ color: Color_Verde }} > Criterios de Búsqueda </h5>
                                </Col>
                            </Col>
                            <Col></Col>
                        </Row>
                    </div>

                    <Container className="border" style={{ background: Color_Blanco }}>

                        <Row className="text-center" style={{ color: Color_Blanco, backgroundColor: `${color}` }}>
                            <Col>{titulo}</Col>
                        </Row>

                        <Container hidden={frame1} className="justify-content-center">

                            <Row className="justify-content-center mt-3 mb-3">
                                <Col>
                                    <label> Búsqueda de Sucursal </label>
                                </Col>
                                <Col>
                                    <Select
                                        key="agen"
                                        showSearch
                                        placeholder="Seleccionar una Sucursal"
                                        optionFilterProp="children"
                                        onChange={onChangeAgencia}
                                        onSearch={onSearchAgencia}
                                        filterOption={(input, option: any) =>
                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        options={
                                            OptionAgencias
                                        }
                                        style={{ width: '210px' }}
                                    />

                                </Col>

                                <Col >
                                    <Checkbox
                                        key="checkcolor"
                                        onChange={handleSelectSucursal}
                                    >
                                        {" "} Sumar Filtro {" "}
                                    </Checkbox>
                                </Col>

                            </Row>



                        </Container>

                        <Container hidden={frame2} className="justify-content-center">
                            <Row className="justify-content-md-center mt-3 mb-3" >
                                <Col >
                                    <label> Búsqueda por Color </label>
                                </Col>
                                <Col>
                                    <Select
                                        key="color"
                                        showSearch
                                        placeholder="Seleccionar un color"
                                        optionFilterProp="children"
                                        onChange={onChangeColor}
                                        onSearch={onSearchColor}
                                        filterOption={(input, option) =>
                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        options={OptionColores}
                                        style={{ width: '210px' }}
                                    />

                                </Col>

                                <Col>

                                    <Checkbox
                                        key="checkcolor"
                                        onChange={handleSelectColor}
                                    >
                                        {" "} Sumar Filtro {" "}
                                    </Checkbox>

                                </Col>

                            </Row>

                        </Container>

                        <Container hidden={frame3} className="justify-content-center">

                            <Row className="justify-content-md-center mt-3 mb-3">
                                <Alert variant="danger">
                                    <p><b>MINI TICKET  </b> {" "} / {" "} <u>Peso</u> {" "} <em>Min: 0.1  Máx : 50 </em> {" "} <b>&nbsp;-</b> {" "} <u>Alto</u> {" "}<em> Min: 0.1 Máx: 50 </em>{" "} <b>&nbsp;-</b> {" "} <u>Largo</u> {" "}<em> Min: 0.1 Máx: 50 </em>{" "} <b>&nbsp;-</b> {" "} <u>Ancho</u> {" "}<em> Min: 0.1 Máx: 50  </em></p>
                                    <p><b>BIG TICKET   </b> {" "} / {" "} <u>Peso</u> {" "} <em>Min: 51   Máx : 100</em> {" "} <b>&nbsp;-</b> {" "} <u>Alto</u> {" "}<em> Min: 51 Máx: 100 </em>{" "} <b>&nbsp;-</b> {" "} <u>Largo</u> {" "}<em> Min: 51 Máx: 100 </em>{" "} <b>&nbsp;-</b> {" "} <u>Ancho</u> {" "}<em> Min: 51 Máx: 100  </em></p>
                                    <p><b>GIGA TICKET  </b> {" "} / {" "} <u>Peso</u> {" "} <em>Min: 101  Máx : +  </em> {" "} <b>&nbsp;-</b> {" "} <u>Alto</u> {" "}<em> Min: 101 Máx: +  </em>{" "} <b>&nbsp;-</b> {" "} <u>Largo</u> {" "}<em> Min: 101 Máx: +  </em>{" "} <b>&nbsp;-</b> {" "} <u>Ancho</u> {" "}<em> Min: 101 Máx: +   </em></p>
                                </Alert>
                            </Row>


                            <Row className="justify-content-md-center mt-3 mb-3">
                                <Col>
                                    <label> Tipo Bulto </label>
                                </Col>
                                <Col>
                                    <Select
                                        key="ticket"
                                        placeholder="Seleccionar un Ticket"
                                        style={{ width: '210px' }}
                                        onChange={handleTicket}
                                        options={OptionsTipoTicket}>
                                    </Select>

                                </Col>
                                <Col>

                                    <Checkbox
                                        value="checkticket"

                                        onChange={handleSelectTipoTicket}
                                    >
                                        {" "} Sumar Filtro {" "}
                                    </Checkbox>

                                </Col>

                            </Row>

                        </Container>

                        <Container hidden={frame4} className="justify-content-center">
                            <Row className="justify-content-md-center mt-3 mb-3">
                                <Alert variant="warning"> Sólo se pueden seleccionar rangos de fechas de 15 dias de diferencia. </Alert>
                            </Row>
                            <Row className="justify-content-md-center mt-3 mb-3">
                                <Col>
                                    <label> Observaciones </label>
                                </Col>
                                <Col className="col-6">
                                    <Space direction="vertical" size={12}>

                                        <RangePicker
                                            key="fechas"
                                            format={dateFormat}
                                            onChange={onChangeDP}
                                        />
                                    </Space>

                                </Col>
                                <Col>

                                    <Checkbox
                                        key="checkfechas"
                                        onChange={handleSelectRangoFecha}
                                    >
                                        {" "} Sumar Filtro {" "}
                                    </Checkbox>


                                </Col>
                            </Row>

                        </Container>


                        {/* TODO: AQUI VOY */}
                        <Container hidden={frame5} className="justify-content-center">
                            <Row className="justify-content-md-center mt-3 mb-3">
                                {/* 
                                <Alert variant="info"> Este Filtro funciona independiente de los demás, por lo que no es posible combinarlo. </Alert> */}
                            </Row>
                            <Row className="justify-content-md-center mt-3 mb-3">
                                <Col>
                                    <label> Observaciones </label>
                                </Col>
                                <Col>
                                    <Input
                                        key="InputDePalabras"
                                        placeholder="Escribir palabra a buscar"
                                        onChange={(e: any) => { onChangePalabraClave(e.target.value); }}
                                    />

                                </Col>
                                <Col>



                                    <Checkbox
                                        key="checkfechas"
                                        onChange={handleSelectPalabraClave}
                                    >
                                        {" "} Sumar Filtro {" "}
                                    </Checkbox>




                                </Col>




                            </Row>



                        </Container>

                    </Container>

                    <hr style={{ color: Color_Verde }} />

                    <div className="w-70 text-center justify-content-center  mt-2 mb-2">

                        {permitirBuscar ?



                            <Button
                                className="shadow"
                                icon={<SearchOutlined />}
                                style={{ color: Color_Blanco, backgroundColor: Color_Verde }}
                                onClick={() => {

                                    images.length = 0;
                                    BusquedaConcentrada(eleccion);

                                }}
                            >
                                Buscar
                            </Button>

                            :


                            <Button
                                ghost
                                disabled
                                className="shadow"
                                icon={<SearchOutlined />}
                            //    style={{ color: "white", backgroundColor: Color_Verde }}

                            >
                                Buscar
                            </Button>




                        }


                    </div>

                </Container>

                {/* 
            // SECCION DE Galeria */}

                <Container fluid="xl" className="rounded mt-3 pt-3 pb-3 shadow"
                    style={{ background: Color_Main_BackGround }}>

                    <div className="text-center justify-content-center">
                        <Row className="justify-content-center mb-3">

                            <Col className="col-3 d-flex justify-content-center mb-2">
                                <Button
                                    block
                                    type="primary"
                                    icon={<PictureOutlined />}
                                    style={{ color: Color_Limpieza, backgroundColor: Color_BackGround_Limpieza }}
                                    className="justify-content-between ">
                                    {" "}  <b>Galeria</b> {" "} </Button>
                            </Col>
                        </Row>
                    </div>


                    <Row>
                        <Stack direction="horizontal" gap={1} className="d-flex justify-content-end">
                            <Button type="primary" style={{ color: Color_Limpieza, backgroundColor: Color_BackGround_Limpieza }} className="justify-content-between " disabled>
                                Total Tickets : <b>{" "}{totalTK}{" "}</b>
                            </Button>
                            <Button type="primary" style={{ color: Color_Limpieza, backgroundColor: Color_BackGround_Limpieza }} className="justify-content-between " disabled>
                                Cantidad por Página
                            </Button>
                            <div className="vr" />
                            <Form.Select size="sm" style={{ width: "80px" }} className=""
                                onChange={(e) => { setCantidadPorPagina(+e.target.value) }}>
                                <option value={16}>16</option>
                                <option value={32}>32</option>
                                <option value={300}>300</option>
                            </Form.Select>

                        </Stack>
                    </Row>

                    {/* CARGA DE GALERIA DINAMICA */}


                    <Row hidden={!busquedaCiega}>

                        {

                            currentImages.map((modalInfoDto: ModalInfo, index: any) => {

                                let largo = modalInfoDto.imagenes.length;

                                if (largo != 0) {

                                    let clase = modalInfoDto.categoria;
                                    let color = "";
                                    let texto = "";

                                    if (clase == "null") {
                                        color = Color_Ticket_SinEstado;
                                    } else if (clase == TK_01) {
                                        color = Color_Ticket_Original;
                                        texto = "Recuperado Redestinado";
                                    } else if (clase == TK_02) {
                                        color = Color_Ticket_Redestinado;
                                        texto = "Recuperado Devuelto";
                                    } else if (clase == TK_03) {
                                        color = Color_Ticket_Devuelto;
                                        texto = "Recuperado Sacar a Reparto";
                                    } else if (clase == TK_04) {
                                        color = Color_Ticket_Rezago;
                                        texto = "Recuperado Cambio Tipo Entrega";
                                    } else {
                                        color = Color_Ticket_Sobrante;
                                        texto = "Recuperado Despachar Sucursal Destino";
                                    }

                                    return (

                                        <Col key={index} md={4} sm={6} xs={12}>
                                            <Card className="ml-2 mr-2 shadow mt-3" >

                                                <Card.Header className="text-center ml-2 mr-2" style={{ background: color }}>
                                                    <Container>
                                                        <Col>
                                                            <Row>
                                                                <label style={{ color: Color_Verde }} > <b> Ticket </b> </label>
                                                            </Row>
                                                            <Row>
                                                                <h5 className="mt-0" style={{ color: Color_Verde }} > {modalInfoDto.ticket} </h5>
                                                            </Row>
                                                            <Row>
                                                                <label className="mt-0" style={{ color: Color_Verde, fontSize: 15 }} >  {texto} </label>
                                                            </Row>

                                                        </Col>
                                                    </Container>


                                                </Card.Header>

                                                <Row className="text-center justify-content-center mt-3">
                                                    <Image.PreviewGroup>
                                                        <Image width={350} src={modalInfoDto.imagenes[0]} fallback={NoImage} alt={'Image' + index + random} key={'Image' + index + random} />
                                                    </Image.PreviewGroup>
                                                </Row>
                                                <Card.Body className="text-center">
                                                    <Col>
                                                        <Row>
                                                            <label> Catidad fotografías : {largo} </label>
                                                        </Row>
                                                        <Row>

                                                            <Tooltip placement="bottom" title="Click Para Información">
                                                                <Button type="primary"
                                                                    icon={<ProfileFilled />}
                                                                    style={{ color: Color_Blanco, backgroundColor: Color_Verde }}
                                                                    onClick={async () => {
                                                                        setColorCardHeader(await ActualizaColor(modalInfoDto));
                                                                        SeleccionAccionInfo(modalInfoDto);
                                                                        ordenDeCarga(modalInfoDto);
                                                                        cargaDatosTicketRecuperado(modalInfoDto);
                                                                        setrecuperacionTipo(texto);
                                                                        // DETALLE 01 
                                                                    }}

                                                                    className="justify-content-between"
                                                                >
                                                                    DETALLE
                                                                </Button>
                                                            </Tooltip>
                                                        </Row>
                                                    </Col>
                                                </Card.Body>
                                            </Card>
                                        </Col>

                                    )

                                } else {



                                    let clase = modalInfoDto.categoria;
                                    let color = "";
                                    let texto = "";

                                    if (clase == "null") {
                                        color = Color_Ticket_SinEstado;
                                    } else if (clase == TK_01) {
                                        color = Color_Ticket_Original;
                                        texto = "Recuperado Redestinado";
                                    } else if (clase == TK_02) {
                                        color = Color_Ticket_Redestinado;
                                        texto = "Recuperado Devuelto";
                                    } else if (clase == TK_03) {
                                        color = Color_Ticket_Devuelto;
                                        texto = "Recuperado Sacar a Reparto";
                                    } else if (clase == TK_04) {
                                        color = Color_Ticket_Rezago;
                                        texto = "Recuperado Cambio Tipo Entrega";
                                    } else {
                                        color = Color_Ticket_Sobrante;
                                        texto = "Recuperado Despachar Sucursal Destino";
                                    }



                                    return (
                                        <Col key={index} md={4} sm={6} xs={12}>
                                            <Card className="ml-2 mr-2 shadow mt-3">
                                                <Card.Header className="text-center" style={{ background: color }}>
                                                    <Container>
                                                        <Col>
                                                            <Row>
                                                                <label style={{ color: Color_Verde }} > <b> Ticket </b> </label>
                                                            </Row>
                                                            <Row>
                                                                <h5 className="mt-0" style={{ color: Color_Verde }} > {modalInfoDto.ticket} </h5>
                                                            </Row>
                                                            <Row>
                                                                <label className="mt-0" style={{ color: Color_Verde, fontSize: 15 }} >  {texto} </label>
                                                            </Row>

                                                        </Col>
                                                    </Container>
                                                </Card.Header>
                                                <Row className="text-center justify-content-center mt-3">
                                                    <Image.PreviewGroup>
                                                        <Image width={350} src={NoImage} fallback={NoImage} alt={'Image' + index} key={'Image' + index + random} />
                                                    </Image.PreviewGroup>
                                                </Row>
                                                <Card.Body className="text-center">
                                                    <Col>
                                                        <Row>
                                                            <label> Catidad fotografías : {largo} </label>
                                                        </Row>
                                                        <Row>
                                                            <Tooltip placement="bottom" title="Click Para Información">
                                                                <Button type="primary"
                                                                    icon={<ProfileFilled />}
                                                                    style={{ color: Color_Blanco, backgroundColor: Color_Verde }}
                                                                    onClick={async () => {

                                                                        setColorCardHeader(await ActualizaColor(modalInfoDto));
                                                                        SeleccionAccionInfo(modalInfoDto);
                                                                        ordenDeCarga(modalInfoDto);
                                                                        cargaDatosTicketRecuperado(modalInfoDto);
                                                                        setrecuperacionTipo(texto);

                                                                        //DETALLE 02

                                                                    }}
                                                                    className="justify-content-between"
                                                                >
                                                                    DETALLE
                                                                </Button>
                                                            </Tooltip>
                                                        </Row>
                                                    </Col>
                                                </Card.Body>
                                            </Card>
                                        </Col>)

                                }
                            })

                        }

                    </Row>

                    <Pagination size="sm" className="mt-3" >

                        {Array.from({ length: totalPages }, (_, i) => (
                            <Pagination.Item
                                key={i}
                                active={i + 1 === currentPage}
                                onClick={() => handlePageChange(i + 1)}
                            >
                                {i + 1}
                            </Pagination.Item>
                        ))

                        }
                        {" "}

                    </Pagination>

                </Container>

                {/* MODAL LOADING */}

                <Modal
                    show={showU}
                    size="sm"
                    backdrop="static"
                    keyboard={false}
                    name="loading"

                >
                    <Modal.Header className="text-center justify-content-center">
                        <img alt="Starken" src={logoSTK} style={{ height: "45px" }} />
                    </Modal.Header>
                    <Modal.Body  >
                        <Container className="text-center">
                            <Spinner animation="border" role="status" variant="success" size="sm" />
                            <Spinner animation="border" role="status" variant="success" />
                        </Container>
                        <Container className="text-center">
                            <h6 style={{ color: Color_Verde }}>Cargando...</h6>
                        </Container>
                        <hr />
                        <Container className="text-center">
                            <h5 style={{ color: Color_Verde }}>{mensaje}</h5>
                        </Container>
                    </Modal.Body>
                </Modal>

                {/* Modal Detalle Información Ticket*/}

                <Modal
                    show={show}
                    fullscreen
                    onHide={handleClose}
                    backdrop="static"
                    keyboard={false}
                    name="detalle"
                    className="text-center justify-content-center shadow"
                >

                    {/* CABECERA */}

                    <Modal.Header style={{ background: colorCardHeader }}>
                        <Modal.Title className="container text-center justify-content-center" style={{ color: Color_Verde }}>
                            <FormOutlined />{" "}
                            DETALLE TICKET {modalInfoDto.ticket} {" "} </Modal.Title>
                    </Modal.Header>

                    {/* BODY */}

                    <Modal.Body style={{ background: colorCardHeader }} >
                        <Container className="text-center">

                            {/* GALERIA DEL MODAL INFORMACION TICKET */}
                            <Row className="text-center justify-content-center">
                                <Image.PreviewGroup>
                                    {
                                        modalInfoDto.imagenes
                                    }
                                </Image.PreviewGroup>
                            </Row>

                            {/* informacion ticket */}
                            <Row>
                                {/* INFORMACION PERMANENTE */}
                                <Container
                                    className="rounded mt-3 pt-3 pb-3 w-40 shadow"
                                    style={{ background: Color_Blanco }}
                                >
                                    <Row>
                                        <Col className="col-4 d-flex justify-content-end">
                                            <label style={{ color: Color_Verde }} ><b>
                                                Ticket TopDesk
                                            </b></label>
                                        </Col>
                                        <Col>
                                            <input size={60} disabled
                                                value={modalInfoDto.ticket}
                                            ></input>
                                        </Col>
                                    </Row>
                                    <hr style={{ color: Color_Verde }} />
                                    <Row>
                                        <Col className="col-4 d-flex justify-content-end">
                                            <label style={{ color: Color_Verde }} ><b>
                                                Orden de Flete
                                            </b></label>
                                        </Col>
                                        <Col>
                                            <input size={60} disabled
                                                value={modalInfoDto.ordenFlete}
                                            ></input>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="col-4 mt-2 d-flex justify-content-end">
                                            <label style={{ color: Color_Verde }} ><b>
                                                Creado por
                                            </b></label>
                                        </Col>
                                        <Col className="mt-2">
                                            <input size={60} disabled
                                                value={modalInfoDto.creador}
                                            ></input>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="col-4 mt-2 d-flex justify-content-end">
                                            <label style={{ color: Color_Verde }} ><b>
                                                Sucursal
                                            </b></label>
                                        </Col>
                                        <Col className="mt-2">
                                            <input size={60} disabled
                                                value={modalInfoDto.agencia}
                                            ></input>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="col-4 mt-2 d-flex justify-content-end">
                                            <label style={{ color: Color_Verde }} ><b>
                                                Fecha Creación
                                            </b></label>
                                        </Col>
                                        <Col className="mt-2">
                                            <input size={60} disabled
                                                value={modalInfoDto.fecha}
                                            ></input>
                                        </Col>
                                    </Row>



                                    <Row>
                                        <Col className="col-4 mt-2 d-flex justify-content-end">
                                            <label style={{ color: Color_Verde }} ><b>
                                                Hora Creación
                                            </b></label>
                                        </Col>
                                        <Col className="mt-2">
                                            <input size={60} disabled
                                                value={modalInfoDto.hora}
                                            ></input>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col className="col-4 mt-2 d-flex justify-content-end">
                                            <label style={{ color: Color_Verde }} ><b>
                                                Tipo Ticket
                                            </b></label>
                                        </Col>
                                        <Col className="mt-2">
                                            <input size={60} disabled
                                                value={modalInfoDto.tipoTicket}
                                            ></input>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col className="col-4 mt-2 d-flex justify-content-end">
                                            <label style={{ color: Color_Verde }} ><b>
                                                Color
                                            </b></label>
                                        </Col>
                                        <Col className="mt-2">
                                            <input size={60} disabled
                                                value={modalInfoDto.color}
                                            ></input>
                                        </Col>
                                    </Row>

                                    <hr style={{ color: Color_Verde }} />

                                    <Row >
                                        <label style={{ color: Color_Verde }}><b>
                                            INFORMACIÓN DE SOLICITUD
                                        </b></label>
                                    </Row>
                                    <Row >
                                        <Container  >
                                            <InputGroup>
                                                <Form.Control
                                                    as="textarea"
                                                    value={modalInfoDto.obs}
                                                    className="mt-1"
                                                    disabled
                                                    style={{ color: Color_Negro, resize: 'none', height: 120 }}

                                                />

                                            </InputGroup>
                                            <Col className="mt-1 d-flex justify-content-end">
                                                <label style={{ color: Color_Gris }}>{modalInfoDto.largoObs}</label>
                                            </Col>
                                        </Container>
                                    </Row>


                                    <Container hidden={enableViewRezago} >

                                        {/* {SeccionSinOF()}

                                        {SeccionFechas()} */}



                                        <div hidden={enableViewSinOf}>

                                            <hr style={{ color: Color_Verde }} />


                                            <Row >
                                                <label style={{ color: Color_Verde }}><b>
                                                    Fechas Orden Flete
                                                </b></label>
                                            </Row>

                                            <Row>
                                                <Col>
                                                    <Row>
                                                        <Col className="col-4 mt-2 d-flex justify-content-end">
                                                            <label style={{ color: Color_Verde }} ><b>
                                                                Creación
                                                            </b></label>
                                                        </Col>
                                                        <Col className="mt-2">
                                                            <input size={11} disabled
                                                                value={modalInfoDto.fechaCreacionOf}
                                                            ></input>
                                                        </Col>

                                                    </Row>

                                                </Col>

                                                <Col>
                                                    <Row>
                                                        <Col className="col-4 mt-2 d-flex justify-content-end">
                                                            <label style={{ color: Color_Verde }} ><b>
                                                                Envio Rezago
                                                            </b></label>
                                                        </Col>
                                                        <Col className="mt-2">
                                                            <input size={11} disabled
                                                                value={modalInfoDto.fechaEnvioRezago}
                                                            ></input>
                                                        </Col>

                                                    </Row>
                                                </Col>

                                            </Row>

                                        </div>

                                        <Row hidden={!AletaOf}>

                                            <Alert className="mt-3 mb-3" variant={"warning"} >

                                                "La Orden de Flete ingresada en el ticket tiene algún problema en el sistema principal."

                                            </Alert>


                                        </Row>

                                    </Container>

                                </Container>

                                {/* SECCION DE INFORMACION DE RECUPERACION */}

                                {selectorAccionInfo == "null" ? (

                                    <>

                                        {
                                            enableViewSinOf ? (

                                                <>
                                                    <Container
                                                        className=" rounded mt-3 pt-3 pb-3 w-40 shadow"
                                                        style={{ background: Color_Blanco }}

                                                    >
                                                        <Row >
                                                            <Col  >
                                                                <h4 style={{ color: Color_Verde }}>
                                                                    GESTIONAR
                                                                </h4>
                                                            </Col>
                                                        </Row>

                                                        <div>
                                                            <Alert variant={"warning"}>
                                                                Bulto no cuenta con OF de bulto ciego, envíe  correo electrónico a <b> la sucursal que registró el ticket IND </b> con la  <b> orden de flete a utilizar </b>, indicando la gestión que se debe realizar.  <br /> En caso contrario indicar los datos para la creación de la OF
                                                            </Alert>
                                                        </div>
                                                    </Container>

                                                </>

                                            ) : (

                                                <>

                                                    {/* SECCION DE REZAGO   */}

                                                    <Container
                                                        hidden={!enableViewRezago}
                                                        className=" rounded mt-3 pt-3 pb-3 w-40 shadow"
                                                        style={{ background: Color_Blanco }}
                                                    >


                                                        <Row >
                                                            <Col>
                                                                <h6 style={{ color: Color_Verde }}>
                                                                    <b> ESTADO REZAGO ORDEN FLETE TICKET </b>
                                                                </h6>
                                                            </Col>
                                                        </Row>

                                                        <Row>
                                                            <Col>

                                                                <Alert variant="warning" >

                                                                    Este bulto fue enviado a rezago con of  <b>{OrdenFleteOriginal}</b>, en caso de requerir recuperar el bulto, <br /> cree un ticket desde el módulo "Buscar encargo para levantar solicitud" con la of indicada.

                                                                </Alert>
                                                            </Col>
                                                        </Row>

                                                        <Row>
                                                            <Col className="col-4 mt-2 d-flex justify-content-end">
                                                                <label style={{ color: Color_Verde }} ><b>
                                                                    OF Bulto Ciego
                                                                </b></label>
                                                            </Col>
                                                            <Col className="mt-2">
                                                                <input size={60} disabled
                                                                    value={OrdenFleteRezago}
                                                                ></input>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col className="col-4 mt-2 d-flex justify-content-end">
                                                                <label style={{ color: Color_Verde }} ><b>
                                                                    OF Rezago
                                                                </b></label>
                                                            </Col>
                                                            <Col className="mt-2">
                                                                <input size={60} disabled
                                                                    value={OrdenFleteOriginal}
                                                                ></input>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col className="col-4 mt-2 d-flex justify-content-end">
                                                                <label style={{ color: Color_Verde }} ><b>
                                                                    Dias
                                                                </b></label>
                                                            </Col>
                                                            <Col className="mt-2">
                                                                <input size={60} disabled
                                                                    value={DiasRezago}
                                                                ></input>
                                                            </Col>
                                                        </Row>

                                                        <hr style={{ color: Color_Verde }} />

                                                        <Row className="mt-2">
                                                            <label style={{ color: Color_Verde }}> <b>
                                                                Motivo
                                                            </b> </label>
                                                        </Row>

                                                        <Row>
                                                            <Container >
                                                                <InputGroup>
                                                                    <Form.Control
                                                                        as="textarea"
                                                                        className="mt-1"
                                                                        value={MotivoRezago}
                                                                        disabled
                                                                        style={{ color: Color_Negro, resize: 'none', height: 120 }}

                                                                    />

                                                                </InputGroup>
                                                                <Col className="mt-1 d-flex justify-content-end">
                                                                    <label style={{ color: Color_Gris }}>{LargoMotivo}</label>
                                                                </Col>
                                                            </Container>
                                                        </Row>

                                                    </Container>

                                                    {/* SECCION DE GESTION */}
                                                    <Container
                                                        hidden={enableViewGestionar}
                                                        className=" rounded mt-3 pt-3 pb-3 w-40 shadow"
                                                        style={{ background: Color_Blanco }}
                                                    >

                                                        <Row >
                                                            <Col  >
                                                                <h4 style={{ color: Color_Verde }}>
                                                                    GESTIONAR
                                                                </h4>
                                                            </Col>
                                                        </Row>

                                                        <div className="container">
                                                            <DataTable columns={columns}
                                                                data={arrayEncargos}
                                                                dense
                                                                fixedHeader
                                                                striped
                                                                subHeaderAlign={Alignment.CENTER}
                                                            />
                                                        </div>
                                                    </Container>
                                                </>

                                            )}

                                    </>

                                ) : (

                                    <>

                                        {/* SECCION INFORMACION RECUPERADO */}

                                        <Container
                                            className=" rounded mt-3 pt-3 pb-3 w-40 shadow"
                                            style={{ background: Color_Blanco }}
                                        >

                                            <Row >
                                                <Col  >
                                                    <h6 style={{ color: Color_Verde }}>
                                                        <b> INFORMACIÓN </b>
                                                    </h6>
                                                </Col>
                                            </Row>

                                            <hr style={{ color: Color_Verde }} />

                                            <Container>

                                                <Row>
                                                    <Col className="col-4 mt-2 d-flex justify-content-end">
                                                        <label style={{ color: Color_Verde }} ><b>
                                                            Tipo Recuperación :
                                                        </b></label>
                                                    </Col>
                                                    <Col className="mt-2">
                                                        <input size={60} disabled
                                                            value={recuperacionTipo}
                                                        ></input>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col className="col-4 mt-2 d-flex justify-content-end">
                                                        <label style={{ color: Color_Verde }} ><b>
                                                            Bulto ya recuperdo, por:
                                                        </b></label>
                                                    </Col>
                                                    <Col className="mt-2">
                                                        <input size={60} disabled
                                                            value={recuperacionAgente}
                                                        ></input>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col className="col-4 mt-2 d-flex justify-content-end">
                                                        <label style={{ color: Color_Verde }} ><b>
                                                            Ticket de Recuperación
                                                        </b></label>
                                                    </Col>
                                                    <Col className="mt-2">
                                                        <input size={60} disabled
                                                            value={recuperacionTicket}
                                                        ></input>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col className="col-4 mt-2 d-flex justify-content-end">
                                                        <label style={{ color: Color_Verde }} ><b>
                                                            Orden Flete Recuperación
                                                        </b></label>
                                                    </Col>
                                                    <Col className="mt-2">
                                                        <input size={60} disabled
                                                            value={recuperacionOrdenflete}
                                                        ></input>
                                                    </Col>
                                                </Row>

                                            </Container>

                                        </Container>

                                    </>
                                )}

                            </Row>

                        </Container>
                    </Modal.Body>

                    {/* FOOTER */}

                    <Modal.Footer style={{ background: colorCardHeader }} >

                        <Button danger type="primary" onClick={() => {
                            handleClose();
                            setrecuperacionTicket("");
                            setrecuperacionAgente("");
                            setrecuperacionOrdenFlete("");
                            setEnableViewSinOf(false);
                            setEnableViewGestionar(false);
                            const newModalInfoDto: any = { ...{} };
                            setModalInfoDto(newModalInfoDto);
                            setShowU(false);
                        }}> Cerrar
                            <CloseCircleOutlined />
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* MODAL GESTIONAR */}

                <Modal
                    show={show1}
                    size="lg"
                    onHide={handleClose1}
                    backdrop="static"
                    keyboard={false}
                    name="loading"
                    className="text-center justify-content-center shadow"
                >
                    <Modal.Header style={{ background: Color_Encabezado }}>
                        <Modal.Title className="container text-center justify-content-center" style={{ color: Color_Verde }}>
                            <EditFilled />{" "}Gestión de Ticket
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ background: Color_Main_BackGround }} >

                        <Container
                            className="rounded mt-3 pt-3 pb-3 w-40 shadow"
                            style={{ background: Color_Blanco }}
                        >

                            <Alert key="warning" variant="warning">
                                <h6>IMPORTANTE</h6>
                                <br />
                                Ingrese la orden de flete original en el campo correspondiente, en el caso en que se encuentre en estado inalterable o no se tenga la orden de flete original, debe dejar el recuadro en blanco para poder gestionar.
                            </Alert>


                        </Container>


                        <Container
                            className="rounded mt-3 pt-3 pb-3 w-40 shadow"
                            style={{ background: Color_Blanco }}
                        >

                            <Container className="justify-content-center" >
                                <Row className="justify-content-center" >
                                    <Button disabled
                                        style={{ color: Color_Verde, backgroundColor: Color_BackGround_Limpieza }}
                                    >
                                        <b> INGRESAR ORDEN DE FLETE ORIGINAL </b></Button>
                                    <Container className="justify-content-center">

                                        <Col className="justify-content-center mt-3">

                                            {estadoBotonBultoCiego ? (<>

                                                <Row >

                                                    <form onSubmit={handleSubmit}>
                                                        <Row>
                                                            <Col>
                                                                <input
                                                                    className="form-control"
                                                                    type="number"
                                                                    pattern="^[0-9]*$"
                                                                    maxLength={9}
                                                                    minLength={3}
                                                                    placeholder="Ej: 12345678"
                                                                    required
                                                                    onChange={(e: any) => {

                                                                        if (e.target.value !== "e") {
                                                                            setOFOrifinal(e.target.value);
                                                                        }

                                                                    }


                                                                    } />{" "}
                                                            </Col>
                                                            <Col className="">
                                                                <button
                                                                    className=" btn btn-outline-success "
                                                                    style={{ color: Color_Verde }}

                                                                >
                                                                    Comprobar{" "}
                                                                    <RocketOutlined style={{ color: Color_Verde, fontSize: "20px" }} />
                                                                </button>
                                                            </Col>
                                                        </Row>
                                                    </form>
                                                </Row>



                                            </>) : (<>

                                                <input disabled />{" "}
                                                <Button ghost disabled>
                                                    Comprobar{" "}
                                                    <RocketOutlined style={{ color: Color_Gris, fontSize: "20px" }} />
                                                </Button>
                                            </>
                                            )}

                                        </Col>
                                        <Col>
                                            <Checkbox className="mt-2" style={{ color: Color_Verde }} onChange={onChange} >{" "} <b>SIN</b> Orden de Flete Original</Checkbox>
                                        </Col>

                                    </Container>
                                </Row>
                            </Container>

                            <hr style={{ color: Color_Verde }} />
                            <Container className="w-70" >


                                {estadoBotonBultoCiego ? (
                                    <Button
                                        ghost
                                        disabled
                                        className="w-70 mt-2"
                                    >
                                        <CheckCircleFilled />
                                        {" "}
                                        Crear Ticket Para Recuperar Bulto
                                    </Button>
                                ) : (
                                    <Button

                                        className="w-70 mt-2" style={{ background: Color_Verde, color: Color_Blanco }}

                                        disabled={DisableBotonEnvio}

                                        onClick={() => {

                                            if (estadoBotonBultoCiego) {

                                            } else {
                                                setDisableBotonEnvio(true);

                                                AccionIngresarOfTicket(modalInfoDto);
                                            }

                                        }}
                                    >
                                        <CheckCircleFilled />
                                        {" "}
                                        Crear Ticket Para Recuperar Bulto
                                    </Button>
                                )}

                            </Container>
                            <Container >
                                <Row>
                                    <Col className="col-1">

                                        {nomColor == "primary" ? (
                                            <Button shape="circle" type="primary" hidden={!progress}>{numeroAPI}</Button>
                                        ) : (

                                            <Button shape="circle" type="primary" hidden={!progress} style={{ background: Color_Verde, color: Color_Blanco }}>{numeroAPI}</Button>
                                        )
                                        }

                                    </Col>
                                    <Col>
                                        <ProgressBar className="mt-2 mb-2" hidden={!progress} animated variant="success" now={CargaBarra} label={`${CargaBarra}%`} />
                                    </Col>
                                </Row>
                            </Container>
                        </Container>
                    </Modal.Body>

                    <Modal.Footer style={{ background: Color_Footer }} >
                        <Button danger type="primary"
                            onClick={() => {
                                handleClose1();
                                setShowU(false);
                                setProgress(false);
                                setEstadoBotonBultoCiego(true);
                                setDisableBotonEnvio(false);
                                setnumeroAPI(7);
                                setnomColor("primary");
                            }}> Cerrar
                            <CloseCircleOutlined />
                        </Button>
                    </Modal.Footer>

                </Modal>

                {/* MODAL REZAGO OF INGRESADA */}

                <Modal
                    show={show2}
                    size="lg"
                    onHide={handleClose2}
                    backdrop="static"
                    keyboard={false}
                    name="loading"
                    className="text-center justify-content-center shadow">

                    <Modal.Header style={{ background: colorCardHeader }}>
                        <Modal.Title className="container text-center justify-content-center" style={{ color: Color_Verde }}>
                            <FormOutlined />{" "}
                            ORDEN DE FLETE INGRESADA CON REZAGO {" "} </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>

                        <Container

                            className=" rounded mt-3 pt-3 pb-3 w-40 shadow"
                            style={{ background: Color_Blanco }}
                        >


                            <Row >
                                <Col>
                                    <h6 style={{ color: Color_Verde }}>
                                        <b> ESTADO REZAGO ORDEN FLETE INGRESADA </b>
                                    </h6>
                                </Col>
                            </Row>

                            <Row>
                                <Col className="col-3 mt-2 d-flex justify-content-end">
                                    <label style={{ color: Color_Verde }} ><b>
                                        OF Rezago
                                    </b></label>
                                </Col>
                                <Col className="mt-2">
                                    <input size={40} disabled
                                        value={OrdenFleteRezago2}
                                    ></input>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="col-3 mt-2 d-flex justify-content-end">
                                    <label style={{ color: Color_Verde }} ><b>
                                        OF Original
                                    </b></label>
                                </Col>
                                <Col className="mt-2">
                                    <input size={40} disabled
                                        value={OrdenFleteOriginal2}
                                    ></input>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="col-3 mt-2 d-flex justify-content-end">
                                    <label style={{ color: Color_Verde }} ><b>
                                        Dias
                                    </b></label>
                                </Col>
                                <Col className="mt-2">
                                    <input size={40} disabled
                                        value={DiasRezago2}
                                    ></input>
                                </Col>
                            </Row>

                            <hr style={{ color: Color_Verde }} />

                            <Row className="mt-2">
                                <label style={{ color: Color_Verde }}> <b>
                                    Motivo
                                </b> </label>
                            </Row>

                            <Row>
                                <Container >
                                    <InputGroup>
                                        <Form.Control
                                            as="textarea"
                                            className="mt-1"
                                            value={MotivoRezago2}
                                            disabled
                                            style={{ color: Color_Negro, resize: 'none', height: 120 }}

                                        />

                                    </InputGroup>
                                    <Col className="mt-1 d-flex justify-content-end">
                                        <label style={{ color: Color_Gris }}> {LargoMotivo2}</label>
                                    </Col>
                                </Container>
                            </Row>

                        </Container>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button danger type="primary" onClick={() => { handleClose1(); setShowU(false) }}> Cerrar
                            <CloseCircleOutlined />
                        </Button>

                        <Button type="primary" style={{ color: Color_Blanco, backgroundColor: Color_Verde }} onClick={() => { setShowU(true); OpenForm(modalInfoDto) }}> Crear Ticket Para Recuperar Bulto
                            <RightSquareFilled />
                        </Button>

                    </Modal.Footer>

                </Modal>


                {/* MODAL VARIOS BULTOS OF ORIGINAL */}

                <Modal
                    show={show3}
                    fullscreen
                    onHide={handleClose3}
                    backdrop="static"
                    keyboard={false}
                    name="VariosBultos"
                    className="text-center justify-content-center shadow"
                    backdropClassName="body"
                >
                    <Modal.Header>
                        <Container>
                            Encargos Orden flete :
                        </Container>

                    </Modal.Header>

                    <Modal.Body>

                        <DataTable columns={columnsOriginal}
                            data={arrayEncargosOriginales}
                            dense
                            fixedHeader
                            striped
                            subHeaderAlign={Alignment.CENTER}
                        />

                    </Modal.Body>


                    <Modal.Footer className="text-center justify-content-center">
                        <Container className="text-center justify-content-center">
                            <Col></Col>

                            <Col>

                                {EncargoSeleccionado.length > 0 ? (
                                    <>
                                        <Alert variant="warning">
                                            <Row>
                                                <Col>
                                                    <label> Encargo Seleccionado :</label>
                                                </Col>
                                                <Col>
                                                    <h5>
                                                        {IndexEncargoSeleccionado}
                                                    </h5>
                                                </Col>
                                                <Col>
                                                    <h5>
                                                        {EncargoSeleccionado}
                                                    </h5>
                                                </Col>
                                            </Row>
                                        </Alert>

                                    </>

                                ) : (
                                    <>
                                        <Col>
                                            <Alert variant="danger">
                                                <Row>
                                                    <Col>
                                                        <label> Encargo Seleccionado :</label>
                                                    </Col>
                                                    <Col>
                                                        <h6>
                                                            "Debe Seleccionar un Encargo de la Lista"
                                                        </h6>
                                                    </Col>
                                                    <Col>

                                                    </Col>
                                                </Row>
                                            </Alert>
                                        </Col>
                                    </>
                                )


                                }
                                <Col></Col>

                                <Row>
                                    <Col></Col>
                                    <Col>
                                        {ESBoton ? (<>
                                            <Button style={{ background: Color_Verde, color: Color_Blanco }}
                                                onClick={() => {
                                                    SegundaParteOfOriginal(RespuestaSegundaParte);
                                                }}
                                            > Continuar </Button>
                                        </>) : (<>
                                            <Button disabled style={{ background: Color_Blanco, color: Color_Verde }}> Continuar </Button>
                                        </>)
                                        }
                                    </Col>
                                    <Col>
                                        <Button style={{ background: Color_Rojo, color: Color_Blanco }}
                                            onClick={() => {
                                                setShow3(false);
                                                setProgress(false);
                                                setCargaBarra(0);
                                                setnumeroAPI(0);
                                                setEncargoSeleccionado("");
                                                setnomColor("primary");
                                            }}
                                        >
                                            Cancelar
                                        </Button>
                                    </Col>
                                    <Col></Col>

                                </Row>
                            </Col>

                        </Container>
                    </Modal.Footer>

                </Modal>

            </>

        </ConfigProvider>
    )
}